import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i1$2 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import * as i3 from '@ngrx/store';
import { createAction, props, createFeatureSelector, createSelector, select, createReducer, on, StoreModule } from '@ngrx/store';
import * as i10 from '@upr-web-primer/gds-button-events';
import { GdsButtonEventsModule } from '@upr-web-primer/gds-button-events';
import * as i11 from '@upr-web-primer/gds-coveo-search';
import { GdsCoveoSearchModule } from '@upr-web-primer/gds-coveo-search';
import * as i2$1 from '@upr-web-primer/gds-notifications';
import { GdsNotificationsModule } from '@upr-web-primer/gds-notifications';
import * as i3$1 from '@upr-web-primer/ms-places';
import { MsPlacesModule } from '@upr-web-primer/ms-places';
import { UprMobileServiceModule } from '@upr-web-primer/upr-mobile-service';
import { DOCUMENT } from '@angular/common';
import * as i8 from '@angular/router';
import { NavigationStart } from '@angular/router';
import * as i1$1 from '@upr-web-primer/app-utils';
import { paramBool, param } from '@upr-web-primer/app-utils';
import * as i4 from '@upr-web-primer/digital-data';
import * as i13 from '@upr-web-primer/gds-common-utility';
import * as i12 from '@upr-web-primer/geolocation';
import { GEO_NON_PRIMARY_RESIDENT_VALUE } from '@upr-web-primer/geolocation';
import * as i14 from '@upr-web-primer/ms-guests';
import * as i15 from '@upr-web-primer/page-labels';
import * as i5 from '@upr-web-primer/storage';
import * as i7 from '@upr-web-primer/tcm-service';
import * as i9 from '@upr-web-primer/wcs-shop';
import { WINDOW } from '@upr-web-primer/window';
import { get, set, forEach, isEmpty } from 'lodash-es';
import { BehaviorSubject, Subject, Subscription, filter, withLatestFrom, take, skip, takeUntil, fromEvent, from, map, of } from 'rxjs';
import * as i1 from '@upr-web-primer/gds-data-model';
import * as i2 from '@upr-web-primer/gds-picture-model';
import { DateTime } from 'luxon';
import { switchMap, map as map$1, catchError, filter as filter$1, concatMap, withLatestFrom as withLatestFrom$1, mergeMap, tap } from 'rxjs/operators';
import * as i4$1 from '@upr-web-primer/gds-poi';

const checkLoginStatus = createAction('[Auth] Check Login Status');
const loginStatus = createAction('[Global Nav] Get Login Status', props());
const updateLoginStatus = createAction('[Global Nav] Update Login Status', props());
const updateProfileSideBar = createAction('[Global Nav] Update Profile Sidebar', props());
const getUserDetails = createAction('[Global Nav] Get User Details');
const userDetailsSuccess = createAction('[Global Nav] Get User Details Success', props());
const userDetailsFailure = createAction('[Global Nav] Get User Details Failure', props());
const updateProfileData = createAction('[Global Nav] Update Profile Sidebar Login State', props());
const getContentIds = createAction('[Global Nav] Get Content Ids');
const getContentIdsSuccess = createAction('[Global Nav] Get Content Ids Success', props());
const getContentIdsFailure = createAction('[Global Nav] Get Content Ids Failure', props());
const contentDisabled = createAction('[Global Nav] MS Content Disabled');
const contentDisabledSuccess = createAction('[Global Nav] MS Content Disabled Success');
const getContent = createAction('[Global Nav] Get MS Content', props());
const getUtilityBarContentSuccess = createAction('[Global Nav] Get Utility Bar Content Success', props());
const getUtilityBarContentFailure = createAction('[Global Nav] Get Utility Bar Content Failure', props());
const getMegaNavContentSuccess = createAction('[Global Nav] Get Mega Nav Content Success', props());
const getMegaNavContentFailure = createAction('[Global Nav] Get Mega Nav Content Failure', props());
const getContentFailure = createAction('[Global Nav] Content Failure', props());
const parseUtilityBarContent = createAction('[Global Nav] Parse Utility Bar Content', props());
const parseUtilityBarContentSuccess = createAction('[Global Nav] Parse Utility Bar Content Success', props());
const parseMegaNavContent = createAction('[Global Nav] Parse Mega Nav Content', props());
const parseMegaNavContentSuccess = createAction('[Global Nav] Parse Mega Nav Content Success', props());
const parseTridionSearchContent = createAction('[Coveo Search] Parse Tridion Search Content', props());
const coveoSearchQuery$1 = createAction('[Coveo Search] Coveo Search', props());
const coveoSearchResults$1 = createAction('[Coveo Search] Coveo Search Results', props());
const coveoSearchFailure = createAction('[Coveo Search] Coveo Search Failure', props());
const reRenderSearchElement = createAction('[Coveo Search] Re-Render SearchBar Gds Element', props());
const extractParkHours = createAction('[Global Nav] Extract Park Hours Data from MS Content', props());
const setTimeZone = createAction('[Set TimeZone Id] Set Resort Timezone from App Environment', props());
const getVenueId = createAction('[Global Nav] Extract Place Id');
const setPlaceIds = createAction('[Global Nav] Set placesIds from tridion park hours', props());
const setPersistentHours = createAction('[Global Nav] Set PersistentHours Data from MS Content', props());
const getMsPlacesParkHours = createAction('[Global Nav] Get MS Places Park Hours');
const getMsPlacesParkHoursSuccess = createAction('[Global Nav] Get MS Places Park Hours Success', props());
const getMsPlacesHoursFailure = createAction('[Global Nav] Get MS Places Park Hours Failure', props());
const extractVenues = createAction('[Global Nav] Get Venues Park Hours', props());
const getVenues = createAction('[Global Nav] Get Venues Park Hours from API');
const getVenuesSuccess = createAction('[Global Nav] Get Venues Park Hours from API Success', props());
const getVenuesFailure = createAction('[Global Nav] Get Venues Park Hours from API Failure', props());
const getUtilityBarSlotCount$1 = createAction('[Global Nav] Get GDS Utility Bar Slot Count');
const createUtilityBarSlots = createAction('[Global Nav] Create GDS Utility Bar Slots');
const updateUtilityBarSlots = createAction('[Global Nav] Set slot counts for utility bar (mobile & desktop)', props());
const updateUtilitySlots = createAction('[Global Nav] Update Mobile Utility Slots', props());
const transformUtilityContent = createAction('[Global Nav] Transform Utility Content');
const transformTridionMegaNavContent = createAction('[Global Nav] Transform Tridion Mega Nav Content', props());
const updateMobileUtility = createAction('[Global Nav] Update Mobile Utility Component Data', props());
const updateUtilityLogo = createAction('[Global Nav] Update Utility Logo Component Data', props());
const updateDesktopUtility = createAction('[Global Nav] Update Desktop Utility Component Data', props());
const updateSearchUtility = createAction('[Global Nav] Update Search Utility Component Data', props());
const updatePersistentParkHoursData = createAction('[Global Nav] Update Persistent Park Hours Component Data', props());
const updatePreNavUtility = createAction('[Global Nav] Update Pre Nav Utility Component Data', props());
const updateDesktopUtilityParkHours = createAction('[Global Nav] Update Desktop Utility Component Data w/ Park Hours', props());
const updateHamburgerNavMega = createAction('[Global Nav] Update Hamburger Nav w/ Mega Nav Content', props());
const updateHamburgerNavMegaProfile = createAction('[Global Nav] Update Hamburger Nav w/ Profile Content', props());
const updateHamburgerNavUtility = createAction('[Global Nav] Update Hamburger Nav with Utility Data', props());
const updatePersistentHours = createAction('[Global Nav] Update Persistent Park Hours Nav with w/ Park Hours');
const transformProfileContent = createAction('[Global Nav] Transform Profile Content', props());
const addUtilityBarLogo = createAction('[Global Nav] Add Utility Bar Logo');
const setMapValue = createAction('[Global Nav] Set GDS Component Data', props());
const updateMapValue = createAction('[Global Nav] Update GDS Component Data', props());
const updateUserGreetingTemplate = createAction('[Global Nav] Update User Greeting Template', props());
const updateMainLinksMegaNav = createAction('[Global Nav] Update GDS Data for Main Links and Mega Nav', props());
const initView$1 = createAction('[Global Nav] Init View');
const prepareView$1 = createAction('[Global Nav] Get View Ready');
const updateView = createAction('[Global Nav] Update View', props());
const setParkHours = createAction('[Global Nav] Set GDS Park Hours content ', props());
const reactivelyLoadParkHours = createAction('[Global Nav] Reactively load park hours');
const updateUtilityBarParkHours = createAction('[Global Nav] Update Utility Bar w/ Park Hours Data');
const updateViewParkHours = createAction('[Global Nav] Update Park Hours in View');
const updateHamburgerParkHours = createAction('[Global Nav] Update Park Hours in hamburger');
const updateNotificationContainer = createAction('[Global Nav] Update GDS Notification Container Data', props());
const updateNotificationCenter = createAction('[Global Nav] Update GDS Notification Center Data ', props());
const extractNavLite = createAction('[Global Nav] Extract GDS Nav Lite version');
const updateNavLite = createAction('[Global Nav] Updated GDS Nav to Nav Lite version success', props());

class GlobalNavParserService {
    constructor(dataService, pictureDataMapper, store) {
        this.dataService = dataService;
        this.pictureDataMapper = pictureDataMapper;
        this.store = store;
        this.notificationData$ = new BehaviorSubject(null);
        this.parkHoursData$ = new BehaviorSubject(null);
    }
    parseUtilityBar(tcmUtilityBar) {
        const parsedUtilityBar = {};
        const utilityBarData = Array.isArray(tcmUtilityBar)
            ? tcmUtilityBar[0]
            : tcmUtilityBar;
        const utilityBarSections = get(utilityBarData, 'MainNavSectionUtilityBar', []);
        const logo = get(utilityBarData, 'icon', null);
        parsedUtilityBar.sections = [];
        utilityBarSections.forEach((section) => {
            const parsedSectionUtilities = [];
            const sectionUtilities = get(section, 'SectionUtility', []);
            sectionUtilities.forEach((utility) => {
                const display = get(utility, 'display', '');
                const dropdownMenu = get(utility, 'dropdownMenu[0]', null);
                const dropdownItems = get(dropdownMenu, 'listItem', []);
                const link = get(utility, 'link[0]', null);
                const tcmId = get(utility, 'tcmId', '').replace('tcm:', '');
                if (dropdownItems.length > 1) {
                    const dropdownData = {
                        ...dropdownMenu,
                    };
                    dropdownData.items = dropdownData.listItem.map((item) => ({
                        link: [item],
                        label: item.label,
                        value: item.label,
                    }));
                    delete dropdownData.listItem;
                    const parsedDropdown = {
                        dropdownMenu: this.dataService.parseContent(dropdownData),
                        display,
                        tcmId,
                    };
                    parsedSectionUtilities.push(parsedDropdown);
                }
                else {
                    const linkData = {
                        ...link,
                        tcmId,
                    };
                    const parsedLink = { link: this.parseUtilityLink(linkData), display };
                    parsedSectionUtilities.push(parsedLink);
                }
            });
            parsedUtilityBar.sections.push(parsedSectionUtilities);
        });
        if (logo) {
            parsedUtilityBar.logo = this.parseLogo(logo);
        }
        return parsedUtilityBar;
    }
    parseMegaNav(tcmMegaNavData) {
        const logo = get(tcmMegaNavData, 'icon', null);
        const megaMenuItems = get(tcmMegaNavData, 'megaMenuItems', []);
        const initialHamburgerNavImage = get(tcmMegaNavData, 'image', []);
        const megaNavData = {};
        if (initialHamburgerNavImage.length > 0) {
            megaNavData.image = this.pictureDataMapper.init(initialHamburgerNavImage[0]);
        }
        if (Array.isArray(megaMenuItems)) {
            megaNavData.megaMenuItems = megaMenuItems.map((item) => {
                if (item.hasOwnProperty('megaSectionItem')) {
                    const items = item.megaSectionItem.map((section) => {
                        if (section.hasOwnProperty('subSectionMenu')) {
                            const subSectionMenu = this.dataService.parseContent({
                                buttons: [...section.subSectionMenu],
                            }).buttons;
                            return {
                                ...section,
                                subSectionMenu,
                            };
                        }
                        return section;
                    });
                    const parsedItem = this.dataService.parseContent({
                        ...item,
                        items,
                    });
                    parsedItem.megaSectionItem = parsedItem.items;
                    delete parsedItem.items;
                    return parsedItem;
                }
                return this.dataService.parseContent({ ...item });
            });
        }
        megaNavData.logo = this.parseLogo(logo);
        return megaNavData;
    }
    parseLogo(logo) {
        if (Array.isArray(logo) && logo[0].image) {
            return this.dataService.parseContent({
                link: [...logo],
            }).link;
        }
    }
    parseUtilityLink(linkData) {
        const component = get(linkData, 'link[0].Component[0]', undefined);
        const parsedLink = this.dataService.parseContent({ link: [linkData] }).link;
        if (parsedLink.svgOptions?.iconName === '') {
            delete parsedLink.svgOptions;
        }
        if (parsedLink.target === 'notifications' && component) {
            this.notificationData$.next(component);
        }
        if (parsedLink.target === 'profile' && component) {
            const profileContent = this.dataService.parseContent({
                ...component,
            });
            this.store.dispatch(transformProfileContent({ profileContent }));
        }
        if (parsedLink.type === 'nav-search') {
            parsedLink.target = 'nav-search-button';
            const parsedContent = this.dataService.parseContent({
                ...get(component, 'GdsGlobalSearch[0]', {}),
            });
            parsedContent?.buttons.forEach((button) => (button.type = 'nav'));
            if (parsedContent) {
                this.store.dispatch(parseTridionSearchContent({ parsedContent }));
            }
        }
        if (parsedLink.type === 'park-hours-modal' && component) {
            const parkHoursComponent = get(component, 'elements[0].component[0]');
            const _blocksData = get(parkHoursComponent, 'blocksData', []);
            const blocksData = _blocksData.map((block) => {
                const _block = { ...block };
                return this.dataService.parseContent(_block);
            });
            this.store.dispatch(extractParkHours({
                parkHours: {
                    ctaButton: { ...parsedLink },
                    title: get(parkHoursComponent, 'heading', ''),
                    blocks: { blocksData },
                },
            }));
        }
        if (parsedLink.type === 'park-hours-link') {
            parsedLink.component = this.dataService.parseContent({ ...component });
            parsedLink.tcmId = get(linkData, 'tcmId', '');
            this.store.dispatch(setPersistentHours({ persistentParkHours: parsedLink }));
        }
        return parsedLink;
    }
}
GlobalNavParserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GlobalNavParserService, deps: [{ token: i1.GdsDataModelService }, { token: i2.GdsPictureModelService }, { token: i3.Store }], target: i0.ɵɵFactoryTarget.Injectable });
GlobalNavParserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GlobalNavParserService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GlobalNavParserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.GdsDataModelService }, { type: i2.GdsPictureModelService }, { type: i3.Store }]; } });

const GDS_GLOBAL_NAV_REPLACED_DEFAULTS = {
    gds_global_nav: {
        enabled: paramBool('$gds_global_nav.enabled$'),
        cookie_name: param('$gds_global_nav.cookie_name$'),
        utility_bar_content_id: param('$gds_global_nav.utility_bar_content_id$'),
        mega_nav_content_id: param('$gds_global_nav.mega_nav_content_id$'),
        use_tridion_config: paramBool('$gds_global_nav.use_tridion_config$'),
        use_ms_places: paramBool('$gds_global_nav.use_ms_places$'),
        app: {
            web_store: param('$gds_global_nav.app.web_store$'),
            packages: param('$gds_global_nav.app.packages$'),
            hotels: param('$gds_global_nav.app.hotels$'),
        }
    },
};
const GDS_GLOBAL_NAV_ENV_DEFAULTS = {
    gds_global_nav: {
        enabled: false,
        cookie_name: 'display_global_nav',
        utility_bar_content_id: 'GDS-Main-Nav-Utility',
        mega_nav_content_id: 'Mega-Nav-main',
        use_tridion_config: false,
        use_ms_places: false,
        app: {
            web_store: 'checkout-login,payment-options,checkout-confirmation',
            packages: 'checkout-login,payment-options,confirmation',
            hotels: 'checkout-login,checkout,confirmation'
        }
    },
};

const NavFeatureKey = 'gds-global-nav';
const GDS_GLOBAL_NAV_LITE = 'gds_global_nav_lite';
const GDS_GLOBAL_NAV = 'gds_global_nav';
const GDS_HAMBURGER_PRIMARY_LAYER_ID = 'hamburger-panel-primary';
const GDS_HAMBURGER_PROFILE_LAYER_ID = 'hamburger-panel-profile';
var CartStorageKeys;
(function (CartStorageKeys) {
    CartStorageKeys["hotels"] = "HOTELS_CART_ITEM_DATA";
    CartStorageKeys["web_store"] = "CART_ITEM_COUNT";
})(CartStorageKeys || (CartStorageKeys = {}));
var GlobalNavDisplayType;
(function (GlobalNavDisplayType) {
    GlobalNavDisplayType["MobileHamburger"] = "mobile_hamburger";
    GlobalNavDisplayType["MobileUtility"] = "mobile_utility";
    GlobalNavDisplayType["Desktop"] = "desktop";
    GlobalNavDisplayType["PersistentParkHours"] = "persistent-park-hours";
})(GlobalNavDisplayType || (GlobalNavDisplayType = {}));
var GlobalNavFieldTemplate;
(function (GlobalNavFieldTemplate) {
    GlobalNavFieldTemplate["MegaMenu"] = "main-nav-links-mega";
    GlobalNavFieldTemplate["MegaCTA"] = "main-nav-links-button";
})(GlobalNavFieldTemplate || (GlobalNavFieldTemplate = {}));

const createNotificationContainer = (notifications = []) => ({
    selector: 'gds-notification-container',
    classList: 'gds-notification-container-primary',
    data: {
        notifications,
    },
});
const preUtilityBar = {
    selector: 'gds-global-nav-pre-utility-bar',
    components: [
        {
            selector: 'gds-global-nav-container',
            components: [],
        },
    ],
};
const utilityBar = {
    selector: 'gds-global-nav-utility-bar',
    components: [],
};
const mainLinks = {
    selector: 'gds-global-nav-main-links',
    components: Array(2)
        .fill(0)
        .map(() => ({
        selector: 'gds-global-nav-container',
        components: [],
        classList: 'large',
    })),
};
const notificationCenter = {
    selector: 'gds-notification-center',
    components: [
        {
            selector: 'gds-notification-container',
            data: {
                notifications: [],
            },
        },
    ],
};
const searchBar = {
    selector: 'gds-search-bar',
    data: {
        searchInput: {
            input: {},
            button: {
                type: 'close',
                ariaLabel: 'Close Button',
            },
        },
        searchResultsPanel: {
            components: [
                {
                    selector: 'gds-heading',
                    id: 'popular-search-heading',
                    data: {
                        heading: '',
                    },
                    classes: 'heading-10',
                    tagType: 'div',
                },
                {
                    selector: 'gds-cta-list',
                    id: 'popular-search',
                    data: {
                        style: {
                            context: 'nav-mega',
                            orientation: 'vertical',
                            showAsColumn: true,
                        },
                        sections: [
                            {
                                buttons: [],
                            },
                        ],
                    },
                },
            ],
        },
    },
};
const mega = {
    selector: 'gds-global-nav-mega',
    components: [],
};
const hamburgerNav = {
    selector: 'gds-hamburger-nav',
    data: {
        backLabel: '',
        components: [],
    },
};
const profile = {
    selector: 'gds-guest-account',
    classList: 'gds-guest-account--parent-comp',
    components: [],
};
const createNavLiteUtility = () => ({
    selector: 'gds-global-nav-utility-bar',
    classList: 'lite',
    components: [
        {
            selector: 'gds-global-nav-container',
            classList: 'small',
            components: [],
        },
    ],
});
const createNavLiteMain = () => ({
    selector: 'gds-global-nav-main-links',
    components: [
        {
            selector: 'gds-global-nav-container',
            classList: 'large',
            components: [],
        },
    ],
});

const specialButtonTypes = {
    'park-hours-link': 'tertiary',
    'park-hours-modal': 'tertiary',
};
const specialButtonElementTypes = {
    cart: true,
    'nav-search-button': true,
    notifications: true,
};
const sortMegaMenuSubSections = (megaMenuSubSections) => {
    if (Array.isArray(megaMenuSubSections) && megaMenuSubSections.length > 0) {
        return megaMenuSubSections
            .map((m) => ({ ...m }))
            .sort((a, b) => {
            if (a.sectionType > b.sectionType)
                return 1;
            else if (a.sectionType < b.sectionType)
                return -1;
            return 0;
        });
    }
    else {
        return megaMenuSubSections;
    }
};
const generateLinkDropdown = (item, isMobile = false) => {
    let result = null;
    const { dropdownMenu, link } = item;
    if (link) {
        result = isMobile
            ? {
                ...link,
                type: 'hamburger-nav-secondary',
            }
            : generateButton(link);
    }
    else if (dropdownMenu) {
        const { heading: placeholder, items: options, defaultValue: value, icon, } = dropdownMenu;
        result = {
            selector: 'gds-dropdown',
            value,
            data: {
                placeholder,
                options,
                dropdownControl: {
                    labelIcon: icon,
                },
            },
            props: {
                preventValueChange: true,
            },
            version: 'v2-light',
        };
    }
    return result;
};
const generatePersistentParkHours = (componentData, parkHoursData) => {
    if (!componentData || !parkHoursData) {
        return false;
    }
    let result = null;
    const calendarBlock = get(componentData, 'component', componentData);
    const _venueId = get(calendarBlock, 'venueID', '');
    const _placeId = get(calendarBlock, 'placeId', '');
    const _tcmId = get(componentData, 'tcmId', '');
    const _label = get(componentData, 'label', '');
    const button = get(calendarBlock, 'ctaButton', false);
    const link = get(button, 'href', '#');
    const parkHours = parkHoursData.find((park) => {
        return (park?.id?.toString()?.toLowerCase() === _placeId.toLowerCase() ||
            park?.id === parseInt(_venueId));
    });
    const displayHours = get(parkHours, 'formattedHours', '');
    const _icon = get(calendarBlock, 'ctaButton.svgOptions.iconName', false) ||
        get(calendarBlock, 'ctaButton[0].svgOptions', '');
    const type = 'park-hours-link';
    result = {
        selector: 'gds-button',
        classList: `gds-button-type-${type} gds-park-hours-link--${_tcmId}`,
        data: {
            ...button,
            type: 'tertiary',
            href: `${link}`,
            label: `${_label} ${displayHours}`,
            svgOptions: {
                iconName: _icon,
            },
        },
        forceContrast: true,
    };
    return result;
};
const generateButton = (link) => {
    const label = get(link, 'label');
    const type = get(link, 'type', '');
    const target = get(link, 'target', '');
    let typeClass = type ? `gds-button-type-${type}` : '';
    const targetClass = target ? `gds-button-target-${target}` : '';
    let href = get(link, 'href', '');
    let data = {};
    let selector = '';
    let replacedType = type;
    if (specialButtonTypes[type]) {
        replacedType = specialButtonTypes[type];
    }
    if (type === 'park-hours-link') {
        const tcmId = get(link, 'tcmId', '');
        typeClass += ` gds-park-hours-link--${tcmId}`;
        href = get(link, 'component.ctaButton.href', href);
    }
    if (type === 'park-hours-modal') {
        selector = 'gds-park-hours';
        data = {
            ctaButton: { ...link, type: replacedType },
        };
    }
    else if (label &&
        !specialButtonElementTypes[type] &&
        !specialButtonElementTypes[target]) {
        selector = 'gds-button';
        data = { ...link, href, type: replacedType };
    }
    else {
        selector = 'gds-button-element';
        data = {
            button: { ...link, href, type: 'global-nav-button' },
        };
    }
    return {
        selector,
        classList: `${targetClass} ${typeClass}`,
        data,
        forceContrast: true,
    };
};
const addImageLogo = (logo) => {
    const data = {
        ...logo,
        target: 'self',
        classList: 'gds-logo',
    };
    return {
        selector: 'gds-image-link',
        data,
    };
};
const generateGdsPicture = (id, imageData, scale) => {
    return {
        selector: 'gds-picture',
        id,
        data: imageData,
        meta: {
            scale,
        },
    };
};
const gdsCtaListHamburgerNav = (id, heading = undefined, buttons = []) => {
    return {
        selector: 'gds-cta-list',
        id,
        data: {
            style: {
                context: 'nav-hamburger',
                orientation: 'vertical',
            },
            heading,
            sections: [
                {
                    buttons,
                },
            ],
        },
    };
};
const createGlobalNavDivider = (id, isVertical, classList) => {
    return {
        selector: 'gds-global-nav-divider',
        id,
        data: {
            orientation: isVertical ? 'vertical' : 'horizontal',
        },
        classList,
    };
};
const generateButtonsFromSubSectionMenu = (subSectionMenu, isPrimary, headingLink = false) => {
    const buttons = [];
    subSectionMenu?.forEach((btn, index) => {
        let type;
        if (headingLink && index === 0) {
            type = 'hamburger-nav-heading-link';
        }
        else if (isPrimary) {
            type = 'hamburger-nav-primary';
        }
        else {
            type = 'hamburger-nav-secondary';
        }
        buttons.push({
            ...btn,
            type,
        });
    });
    return buttons;
};
const createDividerComponent = (id, orientation) => {
    return {
        selector: 'gds-global-nav-divider',
        id,
        data: {
            orientation,
        },
    };
};
const getProfileButtonsByFlag = (buttons) => {
    const buttonsByFlag = {
        loggedIn: [],
        loggedOut: [],
    };
    if (!Array.isArray(buttons))
        return buttonsByFlag;
    buttons.forEach((btn) => {
        const flag = get(btn, 'flag', '');
        if (flag.includes('both')) {
            buttonsByFlag.loggedIn.push(btn);
            buttonsByFlag.loggedOut.push(btn);
            return;
        }
        if (flag.includes('logged-in')) {
            buttonsByFlag.loggedIn.push(btn);
        }
        if (flag.includes('logged-out')) {
            buttonsByFlag.loggedOut.push(btn);
        }
    });
    return buttonsByFlag;
};
const createProfileCtaList = (buttons) => {
    return {
        selector: 'gds-cta-list',
        id: GDS_HAMBURGER_PROFILE_LAYER_ID,
        data: {
            style: {
                context: 'nav-hamburger',
                orientation: 'vertical',
                divider: {
                    orientation: 'horizontal',
                },
            },
            sections: [
                {
                    buttons: buttons.map(({ ...button }) => button),
                },
            ],
        },
    };
};
const createProfileToggles = (buttons, contrastInitialToggle, geoLocationInitialValue) => {
    const components = [];
    buttons.forEach((button, index) => {
        if (index > 0) {
            components.push({
                selector: 'gds-global-nav-divider',
                id: GDS_HAMBURGER_PROFILE_LAYER_ID,
                data: {
                    orientation: 'horizontal',
                },
            });
        }
        if (button.eventName === 'contrast') {
            components.push({
                selector: 'gds-contrast-switch',
                id: GDS_HAMBURGER_PROFILE_LAYER_ID,
                data: {
                    toggle: {
                        label: button.label,
                        positiveLabel: button.positiveLabel,
                        negativeLabel: button.negativeLabel,
                        initialToggle: contrastInitialToggle,
                    },
                },
                meta: {
                    type: 'v2',
                    contrast: contrastInitialToggle,
                },
            });
        }
        else if (button.eventName === 'resident') {
            components.push({
                selector: 'gds-toggle-switch',
                id: GDS_HAMBURGER_PROFILE_LAYER_ID,
                classList: 'gds-toggle-switch--resident',
                data: {
                    toggle: {
                        label: button.label,
                        positiveLabel: button.positiveLabel,
                        negativeLabel: button.negativeLabel,
                        initialToggle: geoLocationInitialValue,
                        type: button.eventName,
                    },
                    eventName: button.eventName,
                },
                meta: {
                    type: 'v2',
                },
            });
        }
    });
    return components;
};
const setProfileData = (profileData, template, isLoggedIn, userNameData, geoLocationInitialValue, contrastInitialToggle) => {
    const loggedInComponents = [];
    const loggedOutComponents = [];
    const reverseName = [true, 'true'].includes(get(profileData, 'reverseName', false));
    const profileIcon = get(profileData, 'profileIcon');
    const showProfileIcon = profileIcon === 'true';
    const allProfileButtons = get(profileData, 'profileButton', []);
    const allProfileToggles = get(profileData, 'profileToggleButton', []);
    const filteredProfileButtons = getProfileButtonsByFlag(allProfileButtons);
    const filteredProfileToggles = getProfileButtonsByFlag(allProfileToggles);
    if (filteredProfileButtons.loggedIn.length > 0) {
        loggedInComponents.push(createProfileCtaList(filteredProfileButtons.loggedIn));
    }
    if (filteredProfileButtons.loggedOut.length > 0) {
        loggedOutComponents.push(createProfileCtaList(filteredProfileButtons.loggedOut));
    }
    if (filteredProfileButtons.loggedIn.length > 0 &&
        filteredProfileToggles.loggedIn.length > 0) {
        loggedInComponents.push(createDividerComponent(GDS_HAMBURGER_PROFILE_LAYER_ID, 'horizontal'));
    }
    if (filteredProfileButtons.loggedOut.length > 0 &&
        filteredProfileToggles.loggedOut.length > 0) {
        loggedOutComponents.push(createDividerComponent(GDS_HAMBURGER_PROFILE_LAYER_ID, 'horizontal'));
    }
    loggedInComponents.push(...createProfileToggles(filteredProfileToggles.loggedIn, contrastInitialToggle, geoLocationInitialValue));
    loggedOutComponents.push(...createProfileToggles(filteredProfileToggles.loggedOut, contrastInitialToggle, geoLocationInitialValue));
    return {
        selector: template.selector,
        classList: template.classList,
        components: isLoggedIn
            ? updateGuestName(userNameData, loggedInComponents, showProfileIcon, reverseName)
            : loggedOutComponents,
        loggedInComponents,
        loggedOutComponents,
        showProfileIcon: showProfileIcon,
        reverseName,
    };
};
const updateGuestName = (userData, loggedInComponents, showBadge, reverse) => {
    let components = [];
    if (userData) {
        const { firstName, lastName } = userData;
        components = components.concat([
            {
                selector: 'gds-guest-name',
                id: GDS_HAMBURGER_PROFILE_LAYER_ID,
                data: {
                    first: firstName,
                    last: lastName,
                    reverse,
                    showBadge,
                },
            },
        ], loggedInComponents);
    }
    return components;
};
const setSearchBarData = (componentData, tridionContent, query, coveoResults, update) => {
    const data = JSON.parse(JSON.stringify(componentData));
    const heading = 'data.searchResultsPanel.components[0].data.heading';
    const buttons = 'data.searchResultsPanel.components[1].data.sections[0].buttons';
    const queryResultsLength = coveoResults?.completions?.length;
    let searchButtons = tridionContent?.buttons;
    let headingMessage;
    if (!update) {
        const inputDefault = {
            type: `data.searchInput.input.type`,
            placeholder: `data.searchInput.input.placeholder`,
            searchIcon: `data.searchInput.input.prependIconName`,
            ariaLabel: `data.searchInput.button.ariaLabel`,
        };
        set(data, inputDefault.type, tridionContent?.type);
        set(data, inputDefault.placeholder, tridionContent?.placeHolder);
        set(data, inputDefault.searchIcon, tridionContent?.prependIconName);
        set(data, inputDefault.ariaLabel, tridionContent?.closebutton);
    }
    if (query === '') {
        headingMessage = tridionContent?.popularSearchHeading;
        set(data, heading, headingMessage);
    }
    else if (queryResultsLength === 0) {
        const noResultHeading = tridionContent?.noResultHeading;
        headingMessage = noResultHeading.replace(new RegExp('#([^ ]+)#', 'g'), query);
        set(data, heading, headingMessage);
    }
    else if (queryResultsLength !== 0) {
        set(data, heading, '');
        headingMessage = 'search suggestion available.';
        searchButtons = coveoResults?.completions?.map((c) => {
            return {
                label: coveoHighlightHtml(c.highlighted),
                type: 'nav-search',
                expression: c.expression,
            };
        });
    }
    set(data, buttons, searchButtons);
    const message = (queryResultsLength ?? searchButtons?.length) === 0
        ? headingMessage
        : `${searchButtons?.length} ${headingMessage}`;
    return { ...data, message };
};
const coveoHighlightHtml = (value) => {
    const parenthesesRegex = /\(([^)\s]+)(?:\s([^\s]+))?\)/g;
    const curlyBracketsRegex = /\{([^}]+)\}/g;
    const squareBracketsRegex = /\[([^\]]+)\]/g;
    const correctionRegex = /\(([^)]+)\)\[([^\]]+)\]/g;
    const patternsAndReplacements = [
        [
            parenthesesRegex,
            (_, content, space) => `<i>${content}${space ? ` ${space}` : ''}</i>`,
        ],
        [curlyBracketsRegex, (_, content) => `<strong>${content}</strong>`],
        [squareBracketsRegex, (_, content) => content],
        [correctionRegex, (_, c1, c2) => `<i>${c1}${c2}</i>`],
    ];
    return patternsAndReplacements.reduce((result, [pattern, replacement]) => result.replace(pattern, replacement), value);
};
const formatMsPlaceHours = (place, timeZone) => {
    let displayHours;
    const weekday = DateTime.now().setZone(timeZone).weekday || 0;
    const hours = get(place, `place.place_hours.periods[${weekday}]`, '');
    const getSimpleTime = (time) => DateTime.fromISO(time)
        .setZone(timeZone)
        .toLocaleString(DateTime.TIME_SIMPLE);
    if (hours?.open?.time && hours?.close?.time) {
        const open = getSimpleTime(hours.open.time);
        const close = getSimpleTime(hours.close.time);
        displayHours = `${open} - ${close}`;
    }
    else {
        displayHours = '';
    }
    return {
        id: get(place, 'place.place_id', ''),
        formattedHours: displayHours,
    };
};
const setParkHoursData = (msPlacesHours, gdsParkHours, timeZone) => {
    const updatedGdsParkHours = JSON.parse(JSON.stringify(gdsParkHours));
    const formattedMsPlacesHours = {};
    const todaysDate = DateTime.now()
        .setZone(timeZone)
        .toLocaleString(DateTime.DATE_FULL);
    const todaysDateTitle = get(updatedGdsParkHours, 'title', '').replace(/##LongDateFormat##/i, todaysDate);
    msPlacesHours?.forEach((place) => {
        formattedMsPlacesHours[place.id] = place.formattedHours;
    });
    const calendarBlocks = get(updatedGdsParkHours, 'blocks.blocksData', []);
    const formattedCalendarBlocks = calendarBlocks.map((block) => {
        const formattedHours = get(formattedMsPlacesHours, block.placeId, '');
        const heading = get(block, 'heading', '').replace(/##parkhours##/i, formattedHours);
        return {
            ...block,
            heading,
        };
    });
    set(updatedGdsParkHours, 'blocks.blocksData', formattedCalendarBlocks);
    set(updatedGdsParkHours, 'title', todaysDateTitle);
    set(updatedGdsParkHours, 'ctaButton.type', 'tertiary');
    return updatedGdsParkHours;
};
const setParkHoursData_venues = (venues, gdsParkHours, timeZone) => {
    const updatedGdsParkHours = JSON.parse(JSON.stringify(gdsParkHours));
    const todaysDate = DateTime.now()
        .setZone(timeZone)
        .toLocaleString(DateTime.DATE_FULL);
    const todaysDateTitle = get(updatedGdsParkHours, 'title', '').replace(/##LongDateFormat##/i, todaysDate);
    const venueIds = get(gdsParkHours, 'blocks.blocksData', []).map((park) => parseInt(park.venueID) || -1);
    if (!venues || venues.length === 0) {
        updatedGdsParkHours?.blocks?.blocksData.forEach((block) => {
            block.heading = '';
        });
    }
    else {
        forEach(venueIds, (venueId, i) => {
            const venue = venues.find((venue) => parseInt(venue.id) === venueId);
            let _hours = get(updatedGdsParkHours, `blocks.blocksData[${i}].heading`, '##parkhours##');
            if (!venue?.hours) {
                _hours = _hours.replace(/##parkhours##/i, '');
            }
            else {
                _hours =
                    _hours !== '' ? _hours.replace(/##parkhours##/i, venue?.hours) : '';
            }
            set(updatedGdsParkHours, `blocks.blocksData[${i}].heading`, _hours);
        });
    }
    set(updatedGdsParkHours, 'title', todaysDateTitle);
    set(updatedGdsParkHours, 'ctaButton.type', 'tertiary');
    return updatedGdsParkHours;
};
const getUtilityBarSlotCount = (tridionContent) => {
    let sections = 0;
    let mobileDings = 0;
    let desktopDings = 0;
    let preUtilityDings = 0;
    tridionContent.forEach((section) => {
        sections++;
        let mobileSlotCount = 0;
        let desktopSlotCount = 0;
        let preUtilitySlotCount = 0;
        section.forEach((item) => {
            const { display } = item;
            if (display?.includes(GlobalNavDisplayType.MobileUtility)) {
                mobileSlotCount++;
            }
            if (display?.includes(GlobalNavDisplayType.Desktop)) {
                desktopSlotCount++;
            }
            if (display?.includes(GlobalNavDisplayType.PersistentParkHours)) {
                preUtilitySlotCount++;
            }
        });
        if (mobileSlotCount === 0) {
            mobileDings++;
        }
        if (desktopSlotCount === 0) {
            desktopDings++;
        }
        if (preUtilitySlotCount === 0) {
            preUtilityDings++;
        }
    });
    const icon = get(tridionContent, 'icon', null);
    if (icon) {
        mobileDings--;
    }
    const mobileSlotCount = Math.max(sections - mobileDings, 3);
    const desktopSlotCount = sections - desktopDings;
    const preUtilitySlotCount = sections - preUtilityDings;
    return { mobileSlotCount, desktopSlotCount, preUtilitySlotCount };
};
const setMobileUtilityBarSlots = (slots, gdsUtilityBar) => {
    const updatedGdsUtilityBar = JSON.parse(JSON.stringify(gdsUtilityBar));
    const { mobile, desktop } = slots;
    const desktopSections = ['start', 'middle', 'end'];
    updatedGdsUtilityBar.components.push(...Array(mobile)
        .fill(0)
        .map(() => ({
        selector: 'gds-global-nav-container',
        components: [],
        classList: 'small',
    })));
    updatedGdsUtilityBar.components.push(...Array(desktop)
        .fill(0)
        .map((_el, index) => ({
        selector: 'gds-global-nav-container',
        components: [],
        classList: `xlarge section-${desktopSections[index]}`,
    })));
    return updatedGdsUtilityBar;
};
const processPreUtilityBarData = (gdsPreUtilityBar) => {
    const components = get(gdsPreUtilityBar, 'components[0].components', []);
    if (!components.length) {
        return null;
    }
    return gdsPreUtilityBar;
};
const setSearchBarUtilityBarData = (gdsUtilityBar, gdsSearchBar) => {
    const updatedGdsUtilityBar = JSON.parse(JSON.stringify(gdsUtilityBar));
    updatedGdsUtilityBar.components.splice(0, 0, gdsSearchBar);
    return updatedGdsUtilityBar;
};
const setUtilityBarLogoData = (tridionContent, gdsUtilityBar) => {
    const updatedGdsUtilityBar = JSON.parse(JSON.stringify(gdsUtilityBar));
    const logo = addImageLogo(tridionContent);
    updatedGdsUtilityBar.components[1].components?.push(logo);
    return updatedGdsUtilityBar;
};
function findObjectWithXLargeAndGdsButton(data, type) {
    let parkHourIndex;
    data.components.forEach((container, i) => {
        if (container?.classList && container?.classList.includes('xlarge')) {
            if (container.components && Array.isArray(container.components)) {
                container.components.forEach((item, j) => {
                    if (item?.classList?.includes(type)) {
                        parkHourIndex = {
                            parentComponentIndex: i,
                            childComponentIndex: j,
                        };
                    }
                });
            }
        }
    });
    return parkHourIndex;
}
const setUtilityBarParkHoursData = (tridionSectionUtilities, gdsUtilityBar, gdsParkHours, parkHoursData) => {
    const updatedGdsUtilityBar = JSON.parse(JSON.stringify(gdsUtilityBar));
    tridionSectionUtilities.forEach((section) => {
        section.forEach((item) => {
            let gdsParkHoursComp = null;
            const { display, link } = item;
            const type = get(link, 'type', '');
            let className = type;
            if (type === 'park-hours-modal' &&
                display?.includes(GlobalNavDisplayType.Desktop)) {
                const _ctaButton = get(item, 'link', {});
                gdsParkHoursComp = {
                    selector: 'gds-park-hours',
                    version: 'v2-light',
                    data: {
                        ...gdsParkHours,
                        ctaButton: { ..._ctaButton, type: 'tertiary' },
                    },
                };
            }
            else if (type === 'park-hours-link' &&
                display?.includes(GlobalNavDisplayType.Desktop)) {
                const tcmId = get(link, 'tcmId', '');
                className = `gds-park-hours-link--${tcmId}`;
                gdsParkHoursComp = generatePersistentParkHours(link, parkHoursData);
            }
            const cpIndex = gdsParkHoursComp
                ? findObjectWithXLargeAndGdsButton(updatedGdsUtilityBar, className)
                : false;
            if (cpIndex) {
                updatedGdsUtilityBar.components[cpIndex.parentComponentIndex].components.splice(cpIndex.childComponentIndex, 1, gdsParkHoursComp);
            }
        });
    });
    return updatedGdsUtilityBar;
};
const setHamburgerNavData_parkHours_content = (gdsHamburgerNav, parkHours) => {
    const updatedGdsHamburgerNav = JSON.parse(JSON.stringify(gdsHamburgerNav));
    const components = get(updatedGdsHamburgerNav, 'data.components', []);
    components.forEach((sectionUtility) => {
        if (sectionUtility.selector === 'gds-block-data-container') {
            sectionUtility.data = setGdsParkHoursHamburgerNavData(parkHours);
        }
    });
    return updatedGdsHamburgerNav;
};
const setGdsParkHoursHamburgerNavData = (parkHours) => {
    const blocks = get(parkHours, 'blocks.blocksData', []);
    const title = get(parkHours, 'title', '');
    return {
        heading: title,
        blocksData: blocks,
    };
};
const setPersistentParkHoursComponent = (tridionSectionUtilities, persistentParkHours) => {
    if (!tridionSectionUtilities || !persistentParkHours) {
        return undefined;
    }
    const updatedUtilities = Object.values(tridionSectionUtilities).map((utility) => {
        return generatePersistentParkHours(utility, persistentParkHours);
    });
    return updatedUtilities;
};
const setPreNavUtilityBarParkHoursData = (gdsPreUtilityBar, gdsPersistantParkHoursComp) => {
    if (!gdsPreUtilityBar) {
        return undefined;
    }
    const updatedGdsPreUtilityBar = JSON.parse(JSON.stringify(gdsPreUtilityBar));
    if (gdsPersistantParkHoursComp) {
        updatedGdsPreUtilityBar.components[0].components.push(...gdsPersistantParkHoursComp);
    }
    return updatedGdsPreUtilityBar;
};
const setHamburgerNavData_utility_content = (tridionContent, gdsHamburgerNav) => {
    const updatedGdsHamburgerNav = JSON.parse(JSON.stringify(gdsHamburgerNav));
    const initialCtaList = get(updatedGdsHamburgerNav, 'data.components[0]');
    const initialCtaListButtons = get(initialCtaList, 'data.sections[0].buttons', []);
    let ctaList = gdsCtaListHamburgerNav(GDS_HAMBURGER_PRIMARY_LAYER_ID);
    if (initialCtaListButtons.length > 0 && tridionContent) {
        updatedGdsHamburgerNav.data.components.push(createGlobalNavDivider(GDS_HAMBURGER_PRIMARY_LAYER_ID), ctaList);
    }
    else {
        updatedGdsHamburgerNav.data.components.push(ctaList);
    }
    tridionContent?.forEach((section, index) => {
        section.forEach((item) => {
            const gdsComp = generateLinkDropdown(item);
            const { display } = item;
            if (display?.includes(GlobalNavDisplayType.MobileHamburger)) {
                if (gdsComp.selector === 'gds-dropdown') {
                    const { data: { placeholder: label, options }, value, } = gdsComp;
                    const labelIcon = gdsComp.data.dropdownControl?.labelIcon;
                    const parentId = `hamburger-panel-${label}`;
                    const hamburgerButton = {
                        id: GDS_HAMBURGER_PRIMARY_LAYER_ID,
                        target: 'hamburger-layer',
                        type: 'hamburger-nav-secondary',
                        label: value || label,
                        href: '',
                        customEventDetail: {
                            layerLink: parentId,
                        },
                        svgOptions: labelIcon ? { iconName: labelIcon } : undefined,
                    };
                    ctaList.data.sections[0].buttons.push(hamburgerButton);
                    const hamburgerNavSubPage = generateSubPageFromDropdownOptions(options, parentId, value, label);
                    updatedGdsHamburgerNav.data.components.push(hamburgerNavSubPage);
                }
                else if (gdsComp.selector === 'gds-park-hours') {
                    const { data: { ctaButton: { label, title, svgOptions }, }, } = gdsComp;
                    const parentId = `hamburger-panel-${label}`;
                    const hamburgerButton = {
                        id: GDS_HAMBURGER_PRIMARY_LAYER_ID,
                        target: 'hamburger-layer',
                        type: 'hamburger-nav-secondary',
                        label: label || title,
                        href: '',
                        customEventDetail: {
                            layerLink: parentId,
                        },
                        svgOptions,
                    };
                    ctaList.data.sections[0].buttons.push(hamburgerButton);
                    updatedGdsHamburgerNav.data.components.push(gdsCtaListHamburgerNav(parentId, hamburgerButton.label), {
                        selector: 'gds-block-data-container',
                        meta: { class: 'gds-hamburger-nav-park-hours' },
                        id: parentId,
                    });
                }
                else {
                    ctaList.data.sections[0].buttons.push({
                        ...generateLinkDropdown(item, true),
                        id: GDS_HAMBURGER_PRIMARY_LAYER_ID,
                        type: 'hamburger-nav-secondary',
                    });
                }
            }
        });
        if (tridionContent.length - 1 > index) {
            ctaList = gdsCtaListHamburgerNav(GDS_HAMBURGER_PRIMARY_LAYER_ID);
            updatedGdsHamburgerNav.data.components.push(ctaList);
        }
    });
    return updatedGdsHamburgerNav;
};
const generateSubPageFromDropdownOptions = (dropDownOptions, parentId, value, heading) => {
    const buttons = dropDownOptionsToButtons(dropDownOptions, value);
    const ctaList = {
        selector: 'gds-cta-list',
        id: parentId,
        data: {
            heading,
            style: {
                context: 'nav-hamburger',
                orientation: 'vertical',
            },
            sections: [
                {
                    buttons,
                },
            ],
        },
    };
    return ctaList;
};
const dropDownOptionsToButtons = (dropDownOptions, value) => {
    const buttons = [];
    dropDownOptions?.forEach((option) => {
        const isActive = option.value === value;
        const button = {
            ...option.link,
            isActive,
            type: 'hamburger-nav-secondary',
        };
        buttons.push(button);
    });
    return buttons;
};
const generateMegaNavSubSection = (id, image) => {
    const megaNavMegaSubSection = {
        selector: 'gds-cta-list',
        data: {
            id,
            style: {
                context: 'nav-mega',
                orientation: 'vertical',
            },
            image,
            sections: [],
        },
    };
    return megaNavMegaSubSection;
};
const gdsCtaListMainLinks = (buttons) => {
    const megaNavMenu = {
        selector: 'gds-cta-list',
        data: {
            style: {
                orientation: 'horizontal',
                context: 'nav-main',
            },
            sections: [{ buttons }],
        },
    };
    return megaNavMenu;
};
const generateMainLinkLink = (link, heading, id) => {
    return {
        ...link,
        type: 'nav',
        label: heading,
        customEventDetail: id,
    };
};
const generateMainLinkCTA = (link) => {
    return {
        selector: 'gds-button',
        data: {
            ...link,
        },
        forceContrast: true,
    };
};
const createHamburgerMegaNavData = (megaNav, addDivder) => {
    const hamburgerMegaNavComponents = [];
    const megaNavCtaList = gdsCtaListHamburgerNav(GDS_HAMBURGER_PRIMARY_LAYER_ID);
    const megaMenuItems = get(megaNav, 'megaMenuItems', []);
    if (!Array.isArray(megaMenuItems) || megaMenuItems.length === 0)
        return [];
    megaMenuItems.forEach((item) => {
        const { heading, display, link, image, fieldTemplate, description } = item;
        let { megaSectionItem: subItems } = item;
        const hasSubSections = Array.isArray(subItems) && subItems.length > 0;
        if (hasSubSections) {
            subItems = sortMegaMenuSubSections(subItems);
        }
        if (display?.includes(GlobalNavDisplayType.MobileHamburger)) {
            const id = `hamburger-panel-${heading}`;
            const hamburgerButton = {
                ...link,
                label: heading,
                fieldTemplate,
                description,
                type: 'hamburger-nav-primary',
            };
            if (hasSubSections) {
                hamburgerButton.customEventDetail = {
                    layerLink: id,
                };
                hamburgerButton.target = 'hamburger-layer';
            }
            if (fieldTemplate === 'profile') {
                hamburgerButton.customEventDetail = {
                    layerLink: GDS_HAMBURGER_PROFILE_LAYER_ID,
                };
                hamburgerButton.target = 'hamburger-layer';
            }
            megaNavCtaList.data.sections[0].buttons.push(hamburgerButton);
            if (hasSubSections) {
                const subNavComponents = createHamburgerSubNavData(heading, subItems, id, image);
                hamburgerMegaNavComponents.push(subNavComponents);
            }
        }
    });
    hamburgerMegaNavComponents.unshift(megaNavCtaList);
    if (addDivder) {
        hamburgerMegaNavComponents.push(createGlobalNavDivider(GDS_HAMBURGER_PRIMARY_LAYER_ID));
    }
    return hamburgerMegaNavComponents.flat(1);
};
const createHamburgerSubNavData = (heading, subNavigationMenus, parentId, image) => {
    const subNavigationComponents = [];
    if (!Array.isArray(subNavigationMenus)) {
        return [];
    }
    let subSectionDetected = false;
    subNavigationMenus?.forEach((subNavMenu, index) => {
        if (subNavMenu.sectionType === 'template-2' && !subSectionDetected) {
            subNavigationComponents.push(createGlobalNavDivider(parentId));
            subSectionDetected = true;
        }
        const { subSectionMenu, image: subImage } = subNavMenu;
        if (!subSectionMenu) {
            return;
        }
        const ctaLists = [];
        let ctaListIndex = 0;
        let startThirdLayer = false;
        subSectionMenu.forEach((button, index) => {
            const heading = button.type === 'heading' || button.type === 'subheading';
            if (index !== 0 && (!startThirdLayer || heading)) {
                ctaListIndex++;
            }
            if (heading) {
                ctaLists[ctaListIndex] = [button];
                startThirdLayer = true;
            }
            else if (startThirdLayer) {
                ctaLists[ctaListIndex].push(button);
            }
            else {
                ctaLists[ctaListIndex] = [button];
                startThirdLayer = false;
            }
        });
        const buttons = [];
        ctaLists.forEach((ctaList) => {
            if (ctaList.length > 1) {
                const thirdLayerComponents = hamburgerThirdLayer(ctaList, buttons, !subSectionDetected, subImage);
                subNavigationComponents.push(...thirdLayerComponents);
            }
            else {
                buttons.push(...generateButtonsFromSubSectionMenu(ctaList, !subSectionDetected));
            }
        });
        const ctaListHeading = index === 0 ? heading : undefined;
        subNavigationComponents.push(gdsCtaListHamburgerNav(parentId, ctaListHeading, buttons));
    });
    if (image) {
        subNavigationComponents.push(generateGdsPicture(parentId, image, true));
    }
    return subNavigationComponents;
};
const createHamburgerProfileData = (gdsProfileSideBar, _userGreetingTemplate) => {
    const profileHamburgerComponents = [];
    const profileSideBarComponents = get(gdsProfileSideBar, 'components', []);
    if (profileSideBarComponents.length === 0) {
        return [];
    }
    profileSideBarComponents.forEach((profile) => {
        profileHamburgerComponents.push(profile);
    });
    return profileHamburgerComponents;
};
const updateUserGreetingButton = (button, userGreetingTemplate, loggedIn, userData) => {
    const userNameGreeting = userGreetingTemplate.replace('##username##', userData.firstName);
    button.label = loggedIn ? `${userNameGreeting}` : button.label;
};
const hamburgerThirdLayer = (subSectionMenu, buttons, isPrimary = true, image) => {
    const thirdLayerComponents = [];
    const [heading, ...thirdLayerButtons] = subSectionMenu;
    const { label, description } = heading;
    const thirdLayerId = `hamburger-panel-third-layer-${label}`;
    buttons.push({
        label,
        description,
        target: 'hamburger-layer',
        type: isPrimary ? 'hamburger-nav-primary' : 'hamburger-nav-secondary',
        svgOptions: heading.svgOptions?.iconName
            ? { iconName: heading.svgOptions }
            : undefined,
        customEventDetail: {
            layerLink: thirdLayerId,
        },
    });
    const ctaListHeading = heading?.type === 'subheading' || (!heading?.href && !heading?.link?.href)
        ? label
        : '';
    thirdLayerComponents.push(gdsCtaListHamburgerNav(thirdLayerId, ctaListHeading, generateButtonsFromSubSectionMenu(ctaListHeading ? thirdLayerButtons : subSectionMenu, false, !ctaListHeading)));
    if (image) {
        thirdLayerComponents.push(generateGdsPicture(thirdLayerId, image, true));
    }
    return thirdLayerComponents;
};
const setMegaNavData_mega_nav_content = (tridionContent, mainLinks, megaNav, logo) => {
    const megaMenuItems = get(tridionContent, 'megaMenuItems', []);
    if (!megaMenuItems) {
        return { mega: null, mainLinks: null };
    }
    const updatedMainLinksNav = JSON.parse(JSON.stringify(mainLinks));
    const updatedMegaNav = JSON.parse(JSON.stringify(megaNav));
    let mainSectionIndx = 1;
    const mainsLinkButtons = [];
    megaMenuItems.forEach((item) => {
        const { heading, link, display, fieldTemplate, image } = item;
        const id = `mega-panel-0${mainSectionIndx}`;
        let { megaSectionItem } = item;
        const hasSubSections = Array.isArray(megaSectionItem) && megaSectionItem.length > 0;
        if (hasSubSections) {
            megaSectionItem = sortMegaMenuSubSections(megaSectionItem);
        }
        if (display?.includes(GlobalNavDisplayType.Desktop)) {
            switch (fieldTemplate) {
                case 'main-nav-links-mega': {
                    const button = generateMainLinkLink(link, heading, id);
                    mainsLinkButtons.push(button);
                    if (hasSubSections) {
                        const subMegaNavContent = setSubMegaNavContent(megaSectionItem, id, image);
                        updatedMegaNav.components.push(subMegaNavContent);
                    }
                    mainSectionIndx++;
                    break;
                }
                case 'main-nav-links-button':
                    {
                        if (link) {
                            const button = generateMainLinkCTA(link);
                            updatedMainLinksNav.components[1].components.push(button);
                        }
                    }
                    break;
            }
        }
    });
    const mainLinklogo = addImageLogo(logo);
    updatedMainLinksNav.components[0].components.push(mainLinklogo);
    if (mainsLinkButtons.length > 0) {
        const mainLinkSection = gdsCtaListMainLinks(mainsLinkButtons);
        updatedMainLinksNav.components[0].components.push(mainLinkSection);
    }
    return { mega: updatedMegaNav, mainLinks: updatedMainLinksNav };
};
const setSubMegaNavContent = (megaSectionItem, id, image) => {
    const subSection = generateMegaNavSubSection(id, image);
    let subSectionDetected = false;
    megaSectionItem.forEach((subMegaSectionItem, i) => {
        if (subMegaSectionItem.sectionType === 'template-2' &&
            !subSectionDetected) {
            subSection.data.style.subSectionIndex = i;
            subSection.data.style.template = subMegaSectionItem.sectionType;
            subSectionDetected = true;
        }
        processSubMegaNav(subSection, subMegaSectionItem);
    });
    return subSection;
};
const processSubMegaNav = (megaNavSection, navData) => {
    const section = { buttons: [] };
    megaNavSection.data.sections.push(section);
    if (navData.subSectionMenu) {
        navData.subSectionMenu.forEach((btn) => {
            const type = btn.type === 'heading' || btn.type === 'subheading'
                ? btn.type
                : 'nav-tertiary';
            section.buttons.push({
                ...btn,
                type,
            });
        });
    }
};
const prepareNavLiteData = (navData) => {
    const mainNavData = JSON.parse(JSON.stringify(navData));
    const utilityBar = get(mainNavData, 'utilityBar.components', []);
    const mainLinks = get(mainNavData, 'mainLinks.components', []);
    const findItemBySelector = (data, selector) => {
        const items = data.filter((obj) => obj.components && !obj.data);
        for (const item of items) {
            const itemExists = item.components.find((component) => component?.selector === selector);
            if (itemExists) {
                return itemExists;
            }
        }
        return null;
    };
    const imageDataSmall = findItemBySelector(utilityBar, 'gds-image-link');
    const imageDataLarge = findItemBySelector(mainLinks, 'gds-image-link');
    if (!imageDataSmall && !imageDataLarge) {
        return null;
    }
    const newNavLiteUtility = createNavLiteUtility();
    const newNavLiteMain = createNavLiteMain();
    set(newNavLiteUtility, 'components[0].components[0]', imageDataSmall || imageDataLarge);
    set(newNavLiteMain, 'components[0].components[0]', imageDataLarge || imageDataSmall);
    return [createNotificationContainer(), newNavLiteUtility, newNavLiteMain];
};
const initView = (gdsNotificationContainer, gdsUtilityBar, gdsMainLinks) => {
    return [gdsNotificationContainer, gdsUtilityBar, gdsMainLinks];
};
const prepareView = (gdsNotificationContainer, gdsPreUtilityBar, gdsUtilityBar, gdsMainLinks, gdsMega, gdsHamburgerNav, gdsProfileSideBar, gdsNotificationCenter) => {
    return [
        gdsNotificationContainer,
        gdsPreUtilityBar,
        gdsUtilityBar,
        gdsMainLinks,
        gdsMega,
        gdsHamburgerNav,
        gdsProfileSideBar,
        gdsNotificationCenter,
    ].filter(Boolean);
};

const globalNavState = createFeatureSelector(NavFeatureKey);
const loggedIn = createSelector(globalNavState, (state) => state.account.loggedIn);
const user = createSelector(globalNavState, (state) => state.account.user);
const selectUserPersonalInfo = createSelector(globalNavState, (state) => state?.account?.user?.personal_info);
const userGreetingTemplate = createSelector(globalNavState, (state) => state?.account?.userGreeting);
const selectUserNameData = createSelector(selectUserPersonalInfo, (personalInfo) => {
    const contacts = personalInfo?.contacts || [];
    const firstContact = contacts[0] || {};
    const firstName = firstContact.first_name || '';
    const lastName = firstContact.last_name || '';
    return { firstName, lastName };
});
const contentIds = createSelector(globalNavState, (state) => state.tridionContent.contentUrlInfo?.contentIds);
const parsedUtilityBarContent = createSelector(globalNavState, (state) => state.tridionContent.parsed.utilityBar);
const parsedUtilityBarSections = createSelector(parsedUtilityBarContent, (state) => state?.sections || []);
const parsedMegaNavContent = createSelector(globalNavState, (state) => state.tridionContent.parsed.megaNav);
const parsedMegaNavItems = createSelector(parsedMegaNavContent, (state) => state.megaMenuItems);
const profileContent = createSelector(globalNavState, (state) => state.tridionContent.parsed.profile);
const tridionSearchContent = createSelector(globalNavState, (state) => state.tridionContent.parsed.search);
const gdsSearchBar = createSelector(globalNavState, (state) => state.gdsComponentData['search']);
const coveoSearchQuery = createSelector(globalNavState, (state) => state.query);
const coveoSearchResults = createSelector(globalNavState, (state) => state.rawContent);
const tcmGdsMegaNavLogo = createSelector(parsedMegaNavContent, (content) => {
    if (!content)
        return;
    const { logo } = content;
    if (logo)
        return logo;
    return undefined;
});
const tcmGdsMainNavUtilityLogo = createSelector(parsedUtilityBarContent, (content) => {
    if (!content)
        return;
    const { logo } = content;
    if (logo)
        return logo;
    return undefined;
});
const slots = createSelector(globalNavState, (state) => state.slots);
const utilityBarSlots = createSelector(globalNavState, (state) => state.slots.utilityBar);
const transformedContent = createSelector(globalNavState, (state) => state.transformedContent);
const tridionPersistentParkHours = createSelector(globalNavState, (state) => state.tridionContent.parsed.persistentParkHours);
const tridionParkHours = createSelector(globalNavState, (state) => state.tridionContent.parsed.parkHours);
const msPlacesHours = createSelector(globalNavState, (state) => state.hoursApi.msPlaces);
const timeZone = createSelector(globalNavState, (state) => state.hoursApi.timeZone);
const placeIds = createSelector(globalNavState, (state) => state.hoursApi.placeIds);
const venues = createSelector(globalNavState, (state) => state.hoursApi.minionService);
const gdsNotificationContainer = createSelector(globalNavState, (state) => state.gdsComponentData.notifications);
const gdsPreUtilityBar = createSelector(globalNavState, (state) => state.gdsComponentData['preUtilityBar']);
const gdsUtilityBar = createSelector(globalNavState, (state) => state.gdsComponentData['utilityBar']);
const gdsProfileSideBar = createSelector(globalNavState, (state) => state.gdsComponentData['profile']);
const gdsHamburgerNav = createSelector(globalNavState, (state) => state.gdsComponentData['hamburgerNav']);
const gdsHamburgerNavData = createSelector(globalNavState, (state) => state.gdsComponentData['hamburgerNav']?.data);
const gdsMainLinks = createSelector(globalNavState, (state) => state.gdsComponentData.mainLinks);
const gdsMega = createSelector(globalNavState, (state) => state.gdsComponentData.mega);
const gdsNotificationCenter = createSelector(globalNavState, (state) => state.gdsComponentData.notificationCenter);
const gdsParkHours = createSelector(globalNavState, (state) => state.gdsComponentData.gdsParkHours);
const gdsParkHoursHamburgerNav = createSelector(globalNavState, (state) => state.gdsComponentData.gdsParkHoursHamburgerNav);
const gdsPersistentParkHoursData = createSelector(globalNavState, (state) => state.gdsComponentData.gdsPersistentParkHours);
const gdsNavLite = createSelector(globalNavState, (state) => state.navLite);
const gdsComponentData = createSelector(globalNavState, (state) => state.gdsComponentData);
const gdsMobileUtilityBarsData = createSelector(parsedUtilityBarSections, gdsUtilityBar, gdsPreUtilityBar, (content, utilityBar, preUtilityBar) => {
    if (!content || !utilityBar)
        return { gdsUtilityBar: utilityBar, gdsPreUtilityBar: preUtilityBar };
    const updatedGdsUtilityBar = JSON.parse(JSON.stringify(utilityBar));
    const updatedGdsPreUtilityBar = JSON.parse(JSON.stringify(preUtilityBar));
    content.forEach((section, i) => {
        section.forEach((item) => {
            const { display } = item;
            if (display?.includes(GlobalNavDisplayType.MobileUtility)) {
                const gdsComp = generateLinkDropdown(item);
                updatedGdsUtilityBar.components[i]?.components?.push(gdsComp);
            }
            if (preUtilityBar && display?.includes(GlobalNavDisplayType.PersistentParkHours)) {
                const gdsComp = generateLinkDropdown(item);
                updatedGdsPreUtilityBar.components[0]?.components?.push(gdsComp);
            }
        });
    });
    return { gdsUtilityBar: updatedGdsUtilityBar, gdsPreUtilityBar: updatedGdsPreUtilityBar };
});
const gdsMobileUtilityBarData = createSelector(parsedUtilityBarSections, gdsUtilityBar, (content, utilityBar) => {
    if (!content || !utilityBar)
        return utilityBar;
    const updatedGdsUtilityBar = JSON.parse(JSON.stringify(utilityBar));
    content.forEach((section, i) => {
        section.forEach((item) => {
            const { display } = item;
            if (display?.includes(GlobalNavDisplayType.MobileUtility)) {
                const gdsComp = generateLinkDropdown(item);
                updatedGdsUtilityBar.components[i]?.components?.push(gdsComp);
            }
        });
    });
    return updatedGdsUtilityBar;
});
const gdsDesktopUtilityBarData = createSelector(parsedUtilityBarSections, gdsUtilityBar, utilityBarSlots, (tridionContent, gdsUtilityBar, utilityBarSlots) => {
    if (!tridionContent || !gdsUtilityBar || !utilityBarSlots)
        return gdsUtilityBar;
    const updatedGdsUtilityBar = JSON.parse(JSON.stringify(gdsUtilityBar));
    let { mobile: offset } = utilityBarSlots;
    if (!utilityBarSlots.desktop) {
        updatedGdsUtilityBar.classList = 'lite';
    }
    tridionContent.forEach((section, i, array) => {
        section.forEach((item) => {
            const { display } = item;
            if (display?.includes(GlobalNavDisplayType.Desktop)) {
                const gdsComp = generateLinkDropdown(item);
                const index = Math.min(offset + i, updatedGdsUtilityBar.components.length - 1);
                const gdsSection = updatedGdsUtilityBar.components[index];
                if (gdsSection) {
                    gdsSection.components?.push(gdsComp);
                    if (utilityBarSlots.desktop === 1 && i > 0) {
                        gdsSection.classList = gdsSection.classList.replace('section-start', 'section-middle');
                    }
                }
            }
        });
        if (utilityBarSlots.desktop >= 3 && i === 1 && array[2]?.length > 0) {
            offset++;
            updatedGdsUtilityBar.components.splice(offset + 1, 0, createGlobalNavDivider('utility', true, 'xlarge'));
        }
    });
    return updatedGdsUtilityBar;
});
const gdsHamburgerNavUtilityBarData = createSelector(parsedUtilityBarSections, gdsHamburgerNav, gdsParkHours, (tridionContent, gdsHamburgerNav, parkHours) => {
    if (!tridionContent || !gdsHamburgerNav || !parkHours)
        return undefined;
    const updatedGdsHamburgerNav = JSON.parse(JSON.stringify(gdsHamburgerNav));
    const id = 'hamburger-panel-0';
    updatedGdsHamburgerNav.data.components.push(createGlobalNavDivider(id));
    tridionContent.forEach((section) => {
        const ctaList = gdsCtaListHamburgerNav(id);
        updatedGdsHamburgerNav.data.components.push(ctaList);
        section.forEach((item) => {
            const gdsComp = generateLinkDropdown(item);
            const { display } = item;
            if (display?.includes(GlobalNavDisplayType.MobileHamburger)) {
                if (gdsComp.selector === 'gds-dropdown') {
                    const { data: { placeholder: label, options }, value, } = gdsComp;
                    const labelIcon = gdsComp.data.dropdownControl?.labelIcon;
                    const parentId = `hamburger-panel-${label}`;
                    const hamburgerButton = {
                        id,
                        target: 'hamburger-layer',
                        type: 'hamburger-nav-secondary',
                        label: value || label,
                        href: '',
                        customEventDetail: {
                            layerLink: parentId,
                        },
                        svgOptions: labelIcon ? { iconName: labelIcon } : undefined,
                    };
                    ctaList.data.sections[0].buttons.push(hamburgerButton);
                    const hamburgerNavSubPage = generateSubPageFromDropdownOptions(options, parentId, value, label);
                    updatedGdsHamburgerNav.data.components.push(hamburgerNavSubPage);
                }
                else if (gdsComp.selector === 'gds-park-hours') {
                    const { data: { ctaButton: { label, title, svgOptions } }, } = gdsComp;
                    const parentId = `hamburger-panel-${label}`;
                    const hamburgerButton = {
                        id,
                        target: 'hamburger-layer',
                        type: 'hamburger-nav-secondary',
                        label: label || title,
                        href: '',
                        customEventDetail: {
                            layerLink: parentId,
                        },
                        svgOptions,
                    };
                    ctaList.data.sections[0].buttons.push(hamburgerButton);
                    const blocks = get(parkHours, 'blocks.blocksData', []);
                    const heading = get(parkHours, 'title', '');
                    updatedGdsHamburgerNav.data.components.push({
                        selector: 'gds-block-data-container',
                        id: parentId,
                        meta: { class: 'gds-hamburger-nav-park-hours' },
                        data: {
                            heading,
                            blocksData: blocks,
                        },
                    });
                }
                else {
                    ctaList.data.sections[0].buttons.push({
                        ...generateLinkDropdown(item, true),
                        id,
                        type: 'hamburger-nav-secondary',
                    });
                }
            }
        });
    });
    return updatedGdsHamburgerNav;
});
const view = createSelector(globalNavState, (state) => state.view);

class GlobalNavService {
    constructor(document, window, appEnvSrv, notificationsService, store, appDataLayer, digitalData, localStorage, sessionStorage, parser, tcmService, router, cartService, gdsButtonEventsService, gdsCoveoSearchService, geoLocationService, commonUtilityService, msGuestsService, pageLabelsResolver) {
        this.document = document;
        this.window = window;
        this.appEnvSrv = appEnvSrv;
        this.notificationsService = notificationsService;
        this.store = store;
        this.appDataLayer = appDataLayer;
        this.digitalData = digitalData;
        this.localStorage = localStorage;
        this.sessionStorage = sessionStorage;
        this.parser = parser;
        this.tcmService = tcmService;
        this.router = router;
        this.cartService = cartService;
        this.gdsButtonEventsService = gdsButtonEventsService;
        this.gdsCoveoSearchService = gdsCoveoSearchService;
        this.geoLocationService = geoLocationService;
        this.commonUtilityService = commonUtilityService;
        this.msGuestsService = msGuestsService;
        this.pageLabelsResolver = pageLabelsResolver;
        this.dataReadyNotification = new Subject();
        this.navLiteDataReady = new Subject();
        this.dataReadyNotification$ = this.dataReadyNotification.asObservable();
        this.navLiteDataReady$ = this.navLiteDataReady.asObservable();
        this.subscriptions = new Subscription();
        this.mainNavSubscriptions = new Subscription();
        this.liteSubscriptions = new Subscription();
        this.notificationSubscriptions = new Subscription();
        this.hideGlobalNav = false;
        this.sidebarComponents = {
            hamburger: 'gds-hamburger-nav',
            profile: 'gds-guest-account',
            notifications: 'gds-notification-center',
        };
        this.notificationsInitialized = false;
        this.pendingReadNotifications = [];
        this.isDestroyed$ = new Subject();
        this.contrastEventHandler = (event) => {
            const contrast = get(event, 'detail');
            this.localStorage.setItem('contrast', contrast);
        };
        this.appEnvSrv.addDefaultValues(GDS_GLOBAL_NAV_ENV_DEFAULTS, GDS_GLOBAL_NAV_REPLACED_DEFAULTS);
        this.gdsGlobalNavConfig = this.appEnvSrv.getEnvVariables('gds_global_nav');
        this.appConfig = this.appEnvSrv.getEnvVariables('app');
        this.pageLabelsResolver.get().then((pageLabels) => {
            this.pageLabels = pageLabels;
        });
        if (this.cartService.cartLoaded$ &&
            this.msGuestsService.helper?.envConfig?.cart_enabled) {
            const cartLoaded$ = this.cartService.cartLoaded$
                .pipe(filter((bool) => bool === true))
                .subscribe(() => this.setCartDataForApp());
            this.subscriptions.add(cartLoaded$);
        }
    }
    get isMobileWebView() {
        return !!this._isMobileWebView;
    }
    init() {
        this.globalNavElem = this.document.querySelector('gds-global-nav');
        if (!this.isDataAvailable) {
            this.store.dispatch(getContentIds());
            this.dataReadyCheck();
            this.subscriptions.add(this.parser.notificationData$.subscribe((data) => {
                if (!data)
                    return;
                this.notificationsService.setNotifications(data);
            }));
            this.subscriptions.add(this.router.events.subscribe((event) => {
                if (event instanceof NavigationStart) {
                    this.closeAllSidebars();
                }
            }));
            this.store
                .pipe(select(gdsComponentData), withLatestFrom(this.store.select(contentIds)), filter(([data, contentIds]) => data.hamburgerNav?.ready &&
                (data.mainLinks?.ready || !contentIds?.global_nav_main) &&
                (data.utilityBar?.ready || !contentIds?.global_nav_utility)), take(1))
                .subscribe(() => {
                this.subscriptions.add(this.msGuestsService.helper.loggedInStatus$.subscribe((loggedIn) => {
                    this.store.dispatch(updateLoginStatus({ loggedIn }));
                }));
            });
        }
        if (this.isMobileWebView) {
            this.initMobileWebViewNav();
            return;
        }
        if (this.globalNavElem) {
            this.initGlobalNavListeners(this.globalNavElem);
        }
    }
    dataReadyCheck() {
        this.navLiteInit();
        this.store
            .pipe(select(view), skip(1), takeUntil(this.isDestroyed$), filter((view) => {
            return view.ready;
        }))
            .subscribe((data) => {
            if (!isEmpty(data?.components)) {
                this.isDataAvailable = data?.ready;
                this.dataReadyNotification.next(data);
            }
        });
    }
    navLiteInit() {
        this.store
            .pipe(select(gdsNavLite), skip(1), takeUntil(this.isDestroyed$), filter(Boolean))
            .subscribe((navLiteData) => {
            if (!isEmpty(navLiteData)) {
                this.navLiteDataReady.next({ components: navLiteData });
            }
        });
    }
    setMobileWebView(isMobileWebView) {
        this._isMobileWebView = isMobileWebView;
    }
    initMobileWebViewNav() {
        if (this.globalNavElem) {
            this.mainNavSubscriptions.add(fromEvent(this.globalNavElem, 'notificationContainerLoaded').subscribe((e) => {
                if (e?.target?.classList?.contains('gds-notification-container-primary')) {
                    this.initNotificationListeners(this.globalNavElem);
                }
            }));
            this.globalNavElem.addEventListener('buttonElementClick', (event) => {
                this.buttonClickHandler(event);
            });
            this.globalNavElem.addEventListener('buttonClicked', (event) => {
                this.buttonClickHandler(event);
            });
        }
    }
    getContent(contentId, publication) {
        return from(this.tcmService.requestContentById(contentId, publication));
    }
    getContentIds() {
        let urlBuilder$;
        if (this.gdsGlobalNavConfig.use_tridion_config) {
            urlBuilder$ = this.tcmService.siteConfig$.pipe(map((config) => {
                const utilityBarContentId = get(config, 'global_nav_utility', '');
                const mainLinksContentId = get(config, 'global_nav_main', '');
                const publication = get(config, 'tridion_pub', '');
                const theme = get(config, 'theme', 'theme-default');
                this.globalNavElem?.setAttribute('theme', theme);
                return this.getPreloadContent(utilityBarContentId, mainLinksContentId, publication);
            }));
        }
        else {
            const utilityBarContentId = this.gdsGlobalNavConfig.utility_bar_content_id;
            const mainLinksContentId = this.gdsGlobalNavConfig.mega_nav_content_id;
            const publication = this.tcmService.tridionEnvConfig.publication;
            const theme = get(this.appConfig, 'gds_theme', 'theme-default');
            this.globalNavElem?.setAttribute('theme', theme);
            const contentUrlInfo = this.getPreloadContent(utilityBarContentId, mainLinksContentId, publication);
            urlBuilder$ = of(contentUrlInfo);
        }
        return urlBuilder$;
    }
    setPreload(preload) {
        if (!this.globalNavElem) {
            return;
        }
        const currentPreload = this.globalNavElem.getAttribute('preload');
        const currentPreloadObj = typeof currentPreload === 'string'
            ? JSON.parse(currentPreload)
            : currentPreload;
        this.preload = {
            ...(currentPreloadObj || {}),
            ...preload,
        };
        this.globalNavElem.setAttribute('preload', JSON.stringify(this.preload));
        if (!this.preload.utilityBar && !this.preload.mainLinks) {
            this.initNotificationListeners(this.globalNavElem);
            this.initUtilityBarComponents();
        }
    }
    getPreloadContent(utilityBarContentId, mainLinksContentId, publication) {
        const contentIds = {
            global_nav_utility: utilityBarContentId,
            global_nav_main: '',
        };
        const preload = {
            utilityBar: false,
            mainLinks: false,
        };
        if (utilityBarContentId) {
            preload.utilityBar = !this.isMobileWebView;
        }
        if (!this.isMobileWebView && mainLinksContentId) {
            preload.mainLinks = true;
            contentIds.global_nav_main = mainLinksContentId;
        }
        this.setPreload(preload);
        return { contentIds, publication };
    }
    logDdlEvents(eventAction, type, results) {
        if (this.appDataLayer.digitalDataEnabled) {
            const eventInfo = this.digitalData.getEventInfoInstance('GlobalNav', eventAction, type, '', new Date().toISOString(), results, this.window.document.URL);
            const eventCategory = this.digitalData.getEventCategoryInstance(get(this.window, 'digitalData.page.category.primaryCategory', ''), get(this.window, 'digitalData.page.category.subCategory1', ''));
            const eventData = this.digitalData.getEventInstance(eventInfo, eventCategory);
            this.digitalData.fireEvent(eventData);
        }
    }
    buttonClickHandler(event) {
        const data = this.commonUtilityService.getComponentData(event.target);
        const btnData = data.button || data;
        const target = get(btnData, 'target', '');
        const type = get(btnData, 'type', '');
        const sidebarComponent = get(this.sidebarComponents, target, '');
        const search = ['nav-search', 'nav'].includes(type) || target === 'nav-search-button';
        const customButtonTargets = ['park-hours-dropdown', 'hamburger-layer'];
        if (sidebarComponent) {
            this.openSidebar(sidebarComponent);
        }
        else if (search) {
            this.gdsCoveoSearchService?.buttonClickHandler(event, btnData);
        }
        else if (target === 'logout') {
            this.msGuestsService.account.logout().finally(() => {
                this.closeAllSidebars();
            });
        }
        else if (!search && !customButtonTargets.includes(target)) {
            this.closeAllSidebars();
            this.gdsButtonEventsService.buttonClickHandler(event);
        }
    }
    openSidebar(target) {
        const sidebarEl = this.globalNavElem?.querySelector(target);
        if (!sidebarEl) {
            return;
        }
        sidebarEl.setAttribute('opened', 'true');
        if (target.toLowerCase() ===
            this.sidebarComponents.notifications.toLowerCase()) {
            const container = sidebarEl.querySelector('.gds-sidebar-container');
            this.readNotificationCenter(container);
        }
    }
    closeSidebar(target) {
        const sidebarEl = this.globalNavElem?.querySelector(target);
        if (!sidebarEl)
            return;
        sidebarEl.setAttribute('opened', 'false');
        if (sidebarEl.tagName.toLowerCase() ===
            this.sidebarComponents.notifications.toLowerCase() &&
            this.pendingReadNotifications.length > 0) {
            this.notificationsService.readNotifications(this.pendingReadNotifications);
            sidebarEl.querySelector('main')?.scrollTo(0, 0);
        }
    }
    initNavLiteListeners(element) {
        if (this.liteSubscriptions) {
            this.liteSubscriptions.unsubscribe();
            this.liteSubscriptions = new Subscription();
        }
        this.initNotificationListeners(element);
    }
    initGlobalNavListeners(element) {
        this.globalNavElem = element;
        if (!this.globalNavElem) {
            return;
        }
        if (this.mainNavSubscriptions) {
            this.mainNavSubscriptions.unsubscribe();
            this.mainNavSubscriptions = new Subscription();
        }
        this.subscriptions.add(this.geoLocationService.geoLocation$
            .pipe(takeUntil(this.isDestroyed$))
            .subscribe((location) => {
            const active = location.region !== GEO_NON_PRIMARY_RESIDENT_VALUE;
            const residentSwitches = this.globalNavElem?.querySelectorAll('.gds-toggle-switch--resident');
            residentSwitches?.forEach((el) => {
                const toggle = el.querySelector('gds-toggle');
                toggle?.changeToggle(active);
            });
        }));
        if (this.isDataAvailable) {
            this.initNotificationListeners(element);
            this.initUtilityBarComponents();
        }
        else {
            this.mainNavSubscriptions.add(fromEvent(this.globalNavElem, 'notificationContainerLoaded').subscribe((e) => {
                if (e?.target?.classList?.contains('gds-notification-container-primary') &&
                    !this.preload.utilityBar &&
                    !this.preload.mainLinks) {
                    this.initNotificationListeners(element);
                }
            }));
            this.mainNavSubscriptions.add(fromEvent(this.globalNavElem, 'globalNavUtilityBarRendered').subscribe(() => {
                if (this.preload.mainLinks) {
                    this.preload.utilityBar = false;
                }
                else {
                    this.setPreload({
                        utilityBar: false,
                        mainLinks: false,
                    });
                }
            }));
            this.mainNavSubscriptions.add(fromEvent(this.globalNavElem, 'globalNavMainLinksLoaded').subscribe(() => {
                if (this.preload.utilityBar) {
                    this.preload.mainLinks = false;
                }
                else {
                    this.setPreload({
                        utilityBar: false,
                        mainLinks: false,
                    });
                }
            }));
        }
        this.mainNavSubscriptions.add(fromEvent(this.window, 'resize').subscribe(() => {
            const viewportWidth = this.window.innerWidth;
            if (viewportWidth >= 1024) {
                this.globalNavElem
                    ?.querySelector('gds-hamburger-nav')
                    ?.setAttribute('opened', 'false');
            }
        }));
        this.globalNavElem.addEventListener('toggleSwitched', (event) => {
            this.toggleSwitchedHandler(event);
        }, false);
        this.globalNavElem.addEventListener('contrastSwitched', (event) => {
            this.contrastEventHandler(event);
        }, false);
        this.globalNavElem.addEventListener('buttonElementClick', (event) => {
            this.buttonClickHandler(event);
        });
        this.globalNavElem.addEventListener('buttonClicked', (event) => {
            this.buttonClickHandler(event);
        });
        this.globalNavElem.addEventListener('sidebarCloseClick', (event) => {
            this.closeSidebar(event.detail);
        });
        const cartKeys = Object.values(CartStorageKeys);
        this.mainNavSubscriptions.add(fromEvent(this.window, 'storage').subscribe((e) => {
            const eventKey = get(e, 'detail.key') || get(e, 'key');
            if (eventKey && cartKeys.includes(eventKey)) {
                this.setCartDataForApp();
            }
        }));
    }
    initUtilityBarComponents() {
        const utilityBarEl = this.globalNavElem?.querySelector('gds-global-nav-utility-bar');
        if (!utilityBarEl)
            return;
        this.pageLabelsResolver.get().finally(() => {
            this.updateNotificationBells();
            this.setCoveoSearch();
            this.closeAllSidebars();
            this.setCartDataForApp();
            this.store.dispatch(updateViewParkHours());
        });
    }
    toggleSwitchedHandler(event) {
        if (get(event, 'detail') === 'resident') {
            this.geoLocation = this.geoLocationService.getGeoLocationObject();
            this.geoLocation.region === GEO_NON_PRIMARY_RESIDENT_VALUE
                ? this.geoLocationService.setGeoLocationToResident()
                : this.geoLocationService.setGeoLocationToNonResident();
        }
    }
    updateComponentData(selector, data) {
        if (!this.globalNavElem || !data || this.hideGlobalNav)
            return;
        const elems = this.globalNavElem.querySelectorAll(selector);
        elems.forEach((el) => {
            el.setAttribute('data', JSON.stringify(data));
        });
    }
    hideGlobalNavElem() {
        this.hideGlobalNav = true;
        if (this.globalNavElem) {
            this.globalNavElem.style.display = 'none';
        }
    }
    updateHamburgerNav(gdsHamburgerNavData) {
        if (!this.globalNavElem)
            return;
        const updatedGdsHamburgerNavData = {
            ...gdsHamburgerNavData,
            backLabel: get(this.pageLabels, 'GDSBackLabel', ''),
        };
        const hamburgerEl = this.globalNavElem.querySelector('gds-hamburger-nav');
        updatedGdsHamburgerNavData !== undefined
            ? hamburgerEl?.setAttribute('data', JSON.stringify(updatedGdsHamburgerNavData))
            : hamburgerEl?.removeAttribute('data');
    }
    updatePreNav(gdsPreNavData) {
        if (!this.globalNavElem)
            return;
        const preNavEl = this.globalNavElem.querySelector('gds-global-nav-pre-utility-bar');
        gdsPreNavData !== undefined
            ? preNavEl?.setAttribute('data', JSON.stringify(gdsPreNavData))
            : preNavEl?.removeAttribute('data');
    }
    updateNavMainLinks(gdsMainLinksData) {
        if (!this.globalNavElem)
            return;
        const mainNavEl = this.globalNavElem.querySelector('gds-global-nav-main-links');
        gdsMainLinksData !== undefined
            ? mainNavEl?.setAttribute('data', JSON.stringify(gdsMainLinksData))
            : mainNavEl?.removeAttribute('data');
    }
    initNotificationListeners(elem) {
        if (!elem)
            return;
        if (this.notificationSubscriptions) {
            this.notificationSubscriptions.unsubscribe();
            this.notificationSubscriptions = new Subscription();
        }
        this.notificationsInitialized = false;
        const primaryNotificationsEl = elem.querySelector('.gds-notification-container-primary');
        const notificationCenterEl = elem.querySelector('gds-notification-center');
        const notificationCenterContainerEl = notificationCenterEl?.querySelector('.gds-sidebar-container');
        const notificationCenterMainEl = notificationCenterContainerEl?.querySelector('.gds-sidebar-container--content');
        if (primaryNotificationsEl) {
            this.notificationSubscriptions.add(fromEvent(primaryNotificationsEl, 'closeNotification').subscribe((event) => {
                const data = this.commonUtilityService.getComponentData(event.detail);
                const id = get(data, 'id', '');
                if (id) {
                    this.notificationsService.readNotifications([id]);
                }
            }));
        }
        if (notificationCenterMainEl) {
            this.notificationSubscriptions.add(fromEvent(notificationCenterMainEl, 'scroll').subscribe(() => {
                this.readNotificationCenter(notificationCenterContainerEl);
            }));
        }
        this.notificationSubscriptions.add(this.notificationsService.$notifications.subscribe((data) => {
            const maxPrimaryNotifications = get(data, 'maxPrimaryNotifications', 2);
            const allNotifications = get(data, 'notifications', []);
            const primaryData = this.commonUtilityService.getComponentData(primaryNotificationsEl);
            const primaryNotifications = get(primaryData, 'notifications', []);
            const unreadLabel = get(this.pageLabels, ['notification.unread.label'], '');
            const newPrimaryNotifications = [];
            const newNotificationCenter = [];
            this.hasNotificationCenter = false;
            this.hasUnreadNotifications = false;
            allNotifications.forEach((notification) => {
                if (notification.type === 'primary' &&
                    !notification.isRead &&
                    maxPrimaryNotifications > newPrimaryNotifications.length) {
                    const inPrimaryContainer = !this.notificationsInitialized ||
                        primaryNotifications.find((n) => n.id === notification.id);
                    if (inPrimaryContainer) {
                        newPrimaryNotifications.push(notification);
                    }
                    else {
                        newNotificationCenter.push(notification);
                        this.hasUnreadNotifications = true;
                    }
                }
                else {
                    newNotificationCenter.push(notification);
                    if (!notification.isRead) {
                        this.hasUnreadNotifications = true;
                    }
                }
            });
            this.hasNotificationCenter = newNotificationCenter.length > 0;
            this.updateNotificationBells();
            notificationCenterEl?.setAttribute('data', JSON.stringify(this.generateNotificationCenter(newNotificationCenter, unreadLabel)));
            this.store.dispatch(updateNotificationCenter({
                propertyName: 'notificationCenter',
                propertyValue: this.generateNotificationCenter(newNotificationCenter, unreadLabel),
            }));
            primaryNotificationsEl?.setAttribute('data', JSON.stringify({
                notifications: newPrimaryNotifications,
            }));
            this.store.dispatch(updateNotificationContainer({
                propertyName: 'notifications',
                propertyValue: createNotificationContainer(newPrimaryNotifications),
            }));
            this.notificationsInitialized = allNotifications.length > 0;
        }));
    }
    generateNotificationCenter(notifications, unreadLabel) {
        const sortedNotifications = notifications
            .map((notification) => {
            const marker = {
                categoryLabel: !notification.isRead ? unreadLabel : '',
            };
            return {
                ...notification,
                marker,
                displayClose: false,
            };
        })
            .sort((n1, n2) => {
            if (n1.isRead != n2.isRead) {
                return n1.isRead ? 1 : -1;
            }
            else if (n1.type === n2.type) {
                return 0;
            }
            else if (n1.type !== 'primary') {
                return 1;
            }
            return -1;
        });
        return {
            selector: 'gds-notification-center',
            components: [
                {
                    selector: 'gds-notification-container',
                    data: {
                        notifications: sortedNotifications,
                    },
                },
            ],
        };
    }
    readNotificationCenter(el) {
        if (!el)
            return;
        const notifications = Array.from(el.querySelectorAll('gds-notification'));
        const readStatusMap = new Map();
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const isRead = readStatusMap.get(entry.target);
                if (entry.isIntersecting && !isRead) {
                    const id = this.commonUtilityService.getComponentData(entry.target).id;
                    this.pendingReadNotifications.push(id);
                    readStatusMap.set(entry.target, true);
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });
        notifications.forEach((notification) => {
            readStatusMap.set(notification, false);
            observer.observe(notification);
        });
    }
    updateNotificationBells() {
        if (!this.globalNavElem)
            return;
        const notificationButtons = Array.from(this.globalNavElem.querySelectorAll('.gds-button-target-notifications'));
        const iconName = this.hasUnreadNotifications
            ? 'bell-with-notification'
            : 'bell';
        notificationButtons.forEach((btn) => {
            const data = this.commonUtilityService.getComponentData(btn);
            btn.data = {
                ...data,
                button: {
                    ...data.button,
                    svgOptions: {
                        ...data.svgOptions,
                        iconName,
                    },
                },
            };
            btn.style.display = this.hasNotificationCenter ? '' : 'none';
        });
    }
    setCartDataForApp() {
        const app = get(this.appConfig, 'name', '');
        if (app === 'hotels') {
            const cartData = this.getCartData(CartStorageKeys.hotels);
            const count = get(cartData, 'count', 0);
            const path = get(cartData, 'path', '');
            this.setCartData(count, {
                hideEmptyCart: true,
                path,
            });
        }
        else {
            const cartItemCount = Number(this.getCartData(CartStorageKeys.web_store) || 0);
            const shoppingCartPath = get(this.pageLabels, 'shoppingCartPath', '');
            const parkTicketsPath = get(this.pageLabels, 'parkTicketsPath', '');
            const emptyCartLabel = get(this.pageLabels, 'shoppingCartEmptyAriaLabel', '');
            this.setCartData(cartItemCount, {
                ariaLabel: !cartItemCount ? emptyCartLabel : undefined,
                dynamicPathReplace: new RegExp(`${shoppingCartPath}|${parkTicketsPath}`),
                dynamicPath: !cartItemCount && app !== 'web-store'
                    ? parkTicketsPath
                    : shoppingCartPath,
            });
        }
    }
    getCartData(storageKey) {
        return (this.localStorage.getItem(storageKey) ||
            this.sessionStorage.getItem(storageKey));
    }
    setCartData(cartItemCount, options) {
        if (!this.globalNavElem) {
            return;
        }
        const isCartEmpty = !cartItemCount;
        const label = isCartEmpty ? '' : String(cartItemCount);
        const ariaLabel = get(options, 'ariaLabel', null) ??
            get(this.pageLabels, 'shoppingCartIconAltText', '');
        const hideEmptyCart = get(options, 'hideEmptyCart', false);
        const path = get(options, 'path', '');
        const dynamicPath = get(options, 'dynamicPath', '');
        const dynamicPathReplace = get(options, 'dynamicPathReplace', '');
        const badge = { label, style: 'Default2' };
        const cartButtons = Array.from(this.globalNavElem.querySelectorAll('.gds-button-type-cart'));
        cartButtons?.forEach((btn) => {
            if (hideEmptyCart && isCartEmpty) {
                btn.style.display = 'none';
                return;
            }
            else if (hideEmptyCart) {
                btn.style.display = null;
            }
            const btnData = this.commonUtilityService.getComponentData(btn);
            let href = get(btnData, 'button.href', '');
            let target = get(btnData, 'button.target', '');
            if (path) {
                href = path;
                target = 'routeLink';
            }
            if (dynamicPath && dynamicPathReplace) {
                href = href.replace(dynamicPathReplace, dynamicPath);
            }
            else if (dynamicPath) {
                href += dynamicPath;
            }
            btn.data = {
                ...btnData,
                button: {
                    ...btnData.button,
                    ariaLabel: ariaLabel.replace('#COUNT#', cartItemCount),
                    href,
                    target,
                },
            };
            btn.badge = badge;
        });
    }
    setCoveoSearch() {
        if (!this.globalNavElem || this.isCoveoLoaded) {
            return;
        }
        this.isCoveoLoaded = true;
        this.gdsCoveoSearchService.init(this.globalNavElem);
        this.mainNavSubscriptions.add(this.gdsCoveoSearchService.coveoSearchQuery$.subscribe((q) => {
            this.store.dispatch(coveoSearchQuery$1({ query: q }));
        }));
    }
    closeAllSidebars() {
        const mainLinks = this.globalNavElem?.querySelector('gds-global-nav-main-links');
        mainLinks?.closeMegaNav();
        const parkHoursModal = this.globalNavElem?.querySelector('gds-park-hours');
        parkHoursModal?.closeDropdown();
        Object.values(this.sidebarComponents).forEach((selector) => {
            this.closeSidebar(selector);
        });
    }
    ngOnDestroy() {
        this.subscriptions?.unsubscribe();
        this.liteSubscriptions?.unsubscribe();
        this.mainNavSubscriptions?.unsubscribe();
        this.notificationSubscriptions?.unsubscribe();
        this.isDestroyed$?.next(true);
        this.isDestroyed$?.unsubscribe();
    }
}
GlobalNavService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GlobalNavService, deps: [{ token: DOCUMENT }, { token: WINDOW }, { token: i1$1.AppEnvironmentService }, { token: i2$1.GdsNotificationsService }, { token: i3.Store }, { token: i4.AppDataLayerService }, { token: i4.DigitalDataService }, { token: i5.LocalStorageService }, { token: i5.SessionStorageService }, { token: GlobalNavParserService }, { token: i7.TcmService }, { token: i8.Router }, { token: i9.CartService }, { token: i10.GdsButtonEventsService }, { token: i11.GdsCoveoSearchService }, { token: i12.GeolocationService }, { token: i13.GdsCommonUtilityService }, { token: i14.MsGuestsService }, { token: i15.PageLabelsResolver }], target: i0.ɵɵFactoryTarget.Injectable });
GlobalNavService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GlobalNavService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GlobalNavService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: Window, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1$1.AppEnvironmentService }, { type: i2$1.GdsNotificationsService }, { type: i3.Store }, { type: i4.AppDataLayerService }, { type: i4.DigitalDataService }, { type: i5.LocalStorageService }, { type: i5.SessionStorageService }, { type: GlobalNavParserService }, { type: i7.TcmService }, { type: i8.Router }, { type: i9.CartService }, { type: i10.GdsButtonEventsService }, { type: i11.GdsCoveoSearchService }, { type: i12.GeolocationService }, { type: i13.GdsCommonUtilityService }, { type: i14.MsGuestsService }, { type: i15.PageLabelsResolver }]; } });

class GlobalNavEffects {
    constructor(actions$, globalNav, store) {
        this.actions$ = actions$;
        this.globalNav = globalNav;
        this.store = store;
        this.errorFlag$ = new Subject();
        this.getContentIds$ = createEffect(() => this.actions$.pipe(ofType(getContentIds), switchMap(() => this.globalNav.getContentIds().pipe(map$1((contentUrlInfo) => {
            if (!contentUrlInfo.contentIds.global_nav_main &&
                !contentUrlInfo.contentIds.global_nav_utility) {
                return contentDisabled();
            }
            return getContentIdsSuccess({
                contentUrlInfo,
            });
        }), catchError((error) => of(getContentIdsFailure({ error })))))));
        this.contentDisabled$ = createEffect(() => this.actions$.pipe(ofType(contentDisabled), map$1(() => {
            this.globalNav.hideGlobalNavElem();
            return contentDisabledSuccess();
        })));
        this.getContentIdsFailure$ = createEffect(() => this.actions$.pipe(ofType(getContentIdsFailure), map$1((error) => {
            this.globalNav.logDdlEvents('Error', 'Failed to load Global Nav Content Ids', error);
            this.globalNav.setPreload({
                utilityBar: false,
                mainLinks: false,
            });
        })), { dispatch: false });
        this.initView$ = this.actions$.pipe(ofType(getContent, getContentIdsSuccess), map$1(() => updateView({ components: [] })));
        this.getUtilityBarContent$ = createEffect(() => this.actions$.pipe(ofType(getContent, getContentIdsSuccess), filter$1((state) => !!state.contentUrlInfo.contentIds.global_nav_utility), switchMap((state) => {
            return this.globalNav
                .getContent(state.contentUrlInfo.contentIds.global_nav_utility ?? '', state.contentUrlInfo.publication ?? '')
                .pipe(map$1((content) => {
                return getUtilityBarContentSuccess({ content });
            }), catchError((error) => of(getUtilityBarContentFailure({ error }))));
        })));
        this.getUtilityBarContentFailure$ = createEffect(() => this.actions$.pipe(ofType(getUtilityBarContentFailure), map$1((error) => {
            this.globalNav.logDdlEvents('Error', 'Failed to load Global Nav Utility Bar', error);
            this.globalNav.setPreload({
                utilityBar: false,
            });
        })), { dispatch: false });
        this.removeUtilityBarContent$ = createEffect(() => this.actions$.pipe(ofType(getContent, getContentIdsSuccess, getUtilityBarContentFailure), filter$1((state) => !get(state, 'contentUrlInfo.contentIds.global_nav_utility', false)), concatMap(() => of(updateMapValue({
            propertyName: 'utilityBar',
            propertyValue: undefined,
        }), updateMapValue({
            propertyName: 'preUtilityBar',
            propertyValue: undefined,
        })))));
        this.parseUtilityBarContent$ = createEffect(() => this.actions$.pipe(ofType(getUtilityBarContentSuccess), map$1((content) => parseUtilityBarContent(content))));
        this.transformUtilityContent$ = createEffect(() => this.actions$.pipe(ofType(updateUtilitySlots), withLatestFrom$1(this.store.pipe(select(gdsMobileUtilityBarsData))), concatMap(([, gdsMobileUtilityBarsData]) => {
            return [
                updateMobileUtility({
                    propertyName: 'utilityBar',
                    propertyValue: gdsMobileUtilityBarsData.gdsUtilityBar,
                }),
                updatePreNavUtility({
                    propertyName: 'preUtilityBar',
                    propertyValue: gdsMobileUtilityBarsData.gdsPreUtilityBar,
                }),
            ];
        })));
        this.updateUtilityLogo$ = createEffect(() => this.actions$.pipe(ofType(updateMobileUtility), withLatestFrom$1(this.store.pipe(select(gdsUtilityBar)), this.store.pipe(select(tcmGdsMainNavUtilityLogo))), mergeMap(([, gdsUtilityBarValue, tridionContent]) => {
            const utilityBarData = setUtilityBarLogoData(tridionContent, gdsUtilityBarValue);
            return of(updateUtilityLogo({
                propertyName: 'utilityBar',
                propertyValue: utilityBarData,
            }));
        })));
        this.updateDesktopUtility$ = createEffect(() => this.actions$.pipe(ofType(updateUtilityLogo), withLatestFrom$1(this.store.pipe(select(gdsDesktopUtilityBarData))), mergeMap(([, gdsDesktopUtilityBarData]) => {
            return of(updateDesktopUtility({
                propertyName: 'utilityBar',
                propertyValue: gdsDesktopUtilityBarData,
            }));
        })));
        this.updateSearchUtility$ = createEffect(() => this.actions$.pipe(ofType(updateDesktopUtility), withLatestFrom$1(this.store.pipe(select(gdsUtilityBar)), this.store.pipe(select(gdsSearchBar))), mergeMap(([_action, gdsUtilityBar, gdsSearchBar]) => {
            const utilityBarData = setSearchBarUtilityBarData(gdsUtilityBar, gdsSearchBar);
            return of(updateSearchUtility({
                propertyName: 'utilityBar',
                propertyValue: utilityBarData,
            }));
        })));
        this.updateHamburgerNavUtility$ = createEffect(() => this.actions$.pipe(ofType(updateSearchUtility), withLatestFrom$1(this.store.pipe(select(gdsHamburgerNav)), this.store.pipe(select(parsedUtilityBarSections))), mergeMap(([_action, gdsUtilityBarValue, tridionContent]) => {
            const hamburgerNavData = setHamburgerNavData_utility_content(tridionContent, gdsUtilityBarValue);
            return [
                updateHamburgerNavUtility({
                    propertyName: 'hamburgerNav',
                    propertyValue: hamburgerNavData,
                }),
            ];
        })));
        this.getMegaNavContent$ = createEffect(() => this.actions$.pipe(ofType(getContent, getContentIdsSuccess), filter$1((state) => !!state.contentUrlInfo.contentIds.global_nav_main), switchMap((state) => {
            return this.globalNav
                .getContent(state.contentUrlInfo.contentIds.global_nav_main ?? '', state.contentUrlInfo.publication ?? '')
                .pipe(map$1((content) => {
                return getMegaNavContentSuccess({ content });
            }), catchError((error) => of(getMegaNavContentFailure({ error }))));
        })));
        this.getMegaNavContentSuccess$ = createEffect(() => this.actions$.pipe(ofType(getMegaNavContentSuccess), map$1((content) => parseMegaNavContent(content))));
        this.getMegaNavContentFailure$ = createEffect(() => this.actions$.pipe(ofType(getMegaNavContentFailure), map$1((error) => {
            this.globalNav.logDdlEvents('Error', 'Failed to load Global Nav Mega Nav', error);
            this.globalNav.setPreload({
                mainLinks: false,
            });
        })), { dispatch: false });
        this.updateHamburgerMegaNav$ = createEffect(() => this.actions$.pipe(ofType(parseMegaNavContentSuccess), withLatestFrom$1(this.store.pipe(select(gdsHamburgerNav)), this.store.pipe(select(gdsProfileSideBar)), this.store.pipe(select(userGreetingTemplate))), concatMap(([action, gdsHamburgerNav, gdsProfileSideBar, userGreetingTemplate,]) => {
            const hamburgerNavData = JSON.parse(JSON.stringify(gdsHamburgerNav));
            let hamburgerNavComponents = hamburgerNavData.data.components;
            hamburgerNavComponents = hamburgerNavComponents.filter((component) => {
                return component.id !== GDS_HAMBURGER_PROFILE_LAYER_ID;
            });
            const addDivider = hamburgerNavComponents.length > 0;
            const hamburgerMegaNavComponents = createHamburgerMegaNavData(action.parsedContent, addDivider);
            const hamburgerProfileComponents = createHamburgerProfileData(gdsProfileSideBar, userGreetingTemplate);
            hamburgerNavComponents.unshift(...hamburgerMegaNavComponents, ...hamburgerProfileComponents);
            set(hamburgerNavData, 'data.components', hamburgerNavComponents);
            return [
                updateHamburgerNavMega({
                    propertyName: 'hamburgerNav',
                    propertyValue: hamburgerNavData,
                }),
            ];
        })));
        this.updateMainLinksMegaNav$ = createEffect(() => this.actions$.pipe(ofType(parseMegaNavContentSuccess), withLatestFrom$1(this.store.pipe(select(gdsMainLinks)), this.store.pipe(select(gdsMega)), this.store.pipe(select(tcmGdsMegaNavLogo))), concatMap(([action, mainMega, subMegaNavs, logo]) => {
            const { mega, mainLinks } = setMegaNavData_mega_nav_content(action.parsedContent, mainMega, subMegaNavs, logo);
            return of(updateMainLinksMegaNav({
                mainLinks,
                mega,
            }));
        })));
        this.prepareView$ = createEffect(() => this.actions$.pipe(ofType(updateHamburgerNavUtility, updateMainLinksMegaNav, updateMapValue, prepareView$1), withLatestFrom$1(this.store.pipe(select(gdsNotificationContainer)), this.store.pipe(select(gdsPreUtilityBar)), this.store.pipe(select(gdsUtilityBar)), this.store.pipe(select(gdsMainLinks)), this.store.pipe(select(gdsMega)), this.store.pipe(select(gdsHamburgerNav)), this.store.pipe(select(gdsProfileSideBar)), this.store.pipe(select(gdsNotificationCenter))), mergeMap(([, gdsNotificationContainer, gdsPreUtilityBar, gdsUtilityBar, gdsMainLinks, gdsMega, gdsHamburgerNav, gdsProfileSideBar, gdsNotificationCenter,]) => {
            let gdsComponents;
            if (this.globalNav.isMobileWebView) {
                gdsComponents = prepareView(gdsNotificationContainer);
            }
            else if (!this.globalNav.isMobileWebView) {
                gdsComponents = prepareView(gdsNotificationContainer, gdsPreUtilityBar, gdsUtilityBar?.ready ? gdsUtilityBar : undefined, gdsMainLinks?.ready ? gdsMainLinks : undefined, gdsMega, gdsHamburgerNav, gdsProfileSideBar, gdsNotificationCenter);
            }
            return of(updateView({ components: gdsComponents }), extractNavLite());
        })));
        this.extractNavLite$ = createEffect(() => this.actions$.pipe(ofType(extractNavLite), withLatestFrom$1(this.store.pipe(select(gdsComponentData))), mergeMap(([_action, navData]) => {
            const navLiteData = prepareNavLiteData(navData);
            return of(updateNavLite({ navLite: navLiteData }));
        })));
    }
}
GlobalNavEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GlobalNavEffects, deps: [{ token: i1$2.Actions }, { token: GlobalNavService }, { token: i3.Store }], target: i0.ɵɵFactoryTarget.Injectable });
GlobalNavEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GlobalNavEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GlobalNavEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: GlobalNavService }, { type: i3.Store }]; } });

class ParkHoursEffects {
    constructor(actions$, globalNav, msPlacesService, gdsPoiService, store, utilities, appDefaults) {
        this.actions$ = actions$;
        this.globalNav = globalNav;
        this.msPlacesService = msPlacesService;
        this.gdsPoiService = gdsPoiService;
        this.store = store;
        this.utilities = utilities;
        this.appDefaults = appDefaults;
        this.errorFlag$ = new Subject();
        this.useMsPlaces = false;
        this.reactivelyLoadParkHours$ = createEffect(() => this.actions$.pipe(ofType(reactivelyLoadParkHours), mergeMap(() => {
            this.useMsPlaces = this.globalNav.gdsGlobalNavConfig.use_ms_places;
            const timeZone = this.appDefaults.UPR_TIME_ZONE;
            return [
                setTimeZone({ timeZone: timeZone }),
                this.useMsPlaces
                    ? getMsPlacesParkHours()
                    : getVenues(),
            ];
        })));
        this.getMsPlacesParkHours$ = createEffect(() => this.actions$.pipe(ofType(getMsPlacesParkHours), withLatestFrom$1(this.store.pipe(select(placeIds)), this.store.pipe(select(timeZone))), mergeMap(([, placeIds, timeZone]) => {
            return from(this.msPlacesService.searchPlaces(placeIds)).pipe(tap((result) => {
                if (result?.results.length <= 0) {
                    this.globalNav.logDdlEvents('Error', 'MS Places returned empty array', '');
                }
            }), map$1((result) => {
                if (!result?.results?.length) {
                    return getMsPlacesHoursFailure({
                        error: 'MS Places returned empty array',
                    });
                }
                const todaysHours = result.results.map((place) => formatMsPlaceHours(place, timeZone));
                return getMsPlacesParkHoursSuccess({
                    msPlacesHours: todaysHours,
                });
            }), catchError((error) => of(getMsPlacesHoursFailure({ error }))));
        })));
        this.getMsPlacesParkHoursSuccess$ = createEffect(() => this.actions$.pipe(ofType(getMsPlacesParkHoursSuccess), withLatestFrom$1(this.store.pipe(select(tridionParkHours)), this.store.pipe(select(msPlacesHours)), this.store.pipe(select(timeZone))), mergeMap(([, tridionParkHours, msPlacesHours, timeZone]) => {
            const updatedGdsParkHoursData = setParkHoursData(msPlacesHours, tridionParkHours, timeZone);
            return of(setParkHours({
                propertyName: 'gdsParkHours',
                propertyValue: updatedGdsParkHoursData,
            }));
        })));
        this.getMsPlacesHoursFailure$ = createEffect(() => this.actions$.pipe(ofType(getMsPlacesHoursFailure), map$1((error) => {
            this.globalNav.logDdlEvents('Error', 'Failed to load Ms Places Hours', error);
            return getVenues();
        })));
        this.getVenues$ = createEffect(() => this.actions$.pipe(ofType(getVenues), withLatestFrom$1(this.store.pipe(select(timeZone))), switchMap(([, timeZone]) => {
            return from(this.gdsPoiService.fetchVenueHours()).pipe(tap({
                error: () => {
                    this.globalNav.logDdlEvents('Error', 'Minion-service returned empty array for venues', '');
                },
            }), map$1((result) => {
                const todaysVenueHours = result?.Results.map((venue) => {
                    const hours = get(venue, 'Hours', []);
                    const todaysHours = this.gdsPoiService.getTodaysHours(hours);
                    return {
                        id: venue.Id,
                        hours: todaysHours,
                        formattedHours: this.gdsPoiService.replaceVenueHoursHashCodes('##parkhours##', todaysHours, timeZone),
                    };
                });
                return getVenuesSuccess({
                    venues: todaysVenueHours,
                });
            }), catchError((error) => of(getVenuesFailure({ error }))));
        })));
        this.getVenuesSuccess$ = createEffect(() => this.actions$.pipe(ofType(getVenuesSuccess), withLatestFrom$1(this.store.pipe(select(tridionParkHours)), this.store.pipe(select(venues)), this.store.pipe(select(timeZone))), mergeMap(([_action, tridionParkHours, venues, timeZone,]) => {
            const updatedGdsParkHours = JSON.parse(JSON.stringify(tridionParkHours));
            if (updatedGdsParkHours) {
                const todaysDate = DateTime.now()
                    .setZone(timeZone)
                    .toLocaleString(DateTime.DATE_FULL);
                const todaysDateTitle = this.utilities.replaceHashCodes(get(tridionParkHours, 'title', ''), {
                    longdateformat: todaysDate,
                });
                const parsedBlocks = get(updatedGdsParkHours, 'blocks.blocksData', []).map((park) => {
                    const venueId = park.venueID ? parseInt(park.venueID) : -1;
                    const hoursData = venues?.find((venue) => parseInt(venue.id) === venueId);
                    const dataString = this.gdsPoiService.replaceVenueHoursHashCodes(JSON.stringify(park), hoursData?.hours, timeZone);
                    return JSON.parse(dataString);
                });
                set(updatedGdsParkHours, 'title', todaysDateTitle);
                set(updatedGdsParkHours, 'blocks.blocksData', parsedBlocks);
                set(updatedGdsParkHours, 'ctaButton.type', 'tertiary');
            }
            return of(setParkHours({
                propertyName: 'gdsParkHours',
                propertyValue: updatedGdsParkHours,
            }));
        })));
        this.getVenuesFailure$ = createEffect(() => this.actions$.pipe(ofType(getVenuesFailure), map$1((error) => {
            this.globalNav.logDdlEvents('Error', 'Failed to fetch venues from Minion Service', error);
            return getVenuesSuccess({
                venues: [],
            });
        })));
        this.setParkHours$ = createEffect(() => this.actions$.pipe(ofType(setParkHours), mergeMap(() => [
            updateUtilityBarParkHours(),
            updateHamburgerParkHours(),
        ])));
        this.updateHamburgerParkHours$ = createEffect(() => this.actions$.pipe(ofType(updateHamburgerParkHours), withLatestFrom$1(this.store.pipe(select(gdsHamburgerNav)), this.store.pipe(select(gdsParkHours))), mergeMap(([_action, gdsUtilityBarValue, parkHours]) => {
            const hamburgerNavData = setHamburgerNavData_parkHours_content(gdsUtilityBarValue, parkHours);
            return [
                updateMapValue({
                    propertyName: 'hamburgerNav',
                    propertyValue: hamburgerNavData,
                }),
            ];
        })));
        this.updateUtilityBarParkHours$ = createEffect(() => this.actions$.pipe(ofType(updateUtilityBarParkHours), withLatestFrom$1(this.store.pipe(select(parsedUtilityBarSections)), this.store.pipe(select(gdsUtilityBar)), this.store.pipe(select(gdsParkHours)), this.store.pipe(select(msPlacesHours)), this.store.pipe(select(venues))), switchMap(([, tridionUtilityContent, gdsUtilityBar, gdsParkHours, msPlacesHours, venues,]) => {
            const parkHoursData = venues?.length ? venues : msPlacesHours;
            const updatedUtilityBarData = setUtilityBarParkHoursData(tridionUtilityContent, gdsUtilityBar, gdsParkHours, parkHoursData);
            return of(updateDesktopUtilityParkHours({
                propertyName: 'utilityBar',
                propertyValue: updatedUtilityBarData,
            }));
        })));
        this.updatePersistentParkHoursData$ = createEffect(() => this.actions$.pipe(ofType(updateDesktopUtilityParkHours), withLatestFrom$1(this.store.pipe(select(tridionPersistentParkHours)), this.store.pipe(select(msPlacesHours)), this.store.pipe(select(venues))), switchMap(([, tridionPersistentParkHours, msPlacesHours, venues]) => {
            const parkHoursData = this.useMsPlaces ? msPlacesHours : venues;
            const updatedPreUtilityBarParkHours = setPersistentParkHoursComponent(tridionPersistentParkHours, parkHoursData);
            return of(updatePersistentParkHoursData({
                propertyName: 'gdsPersistentParkHours',
                propertyValue: updatedPreUtilityBarParkHours,
            }));
        })));
        this.updateViewParkHours$ = createEffect(() => this.actions$.pipe(ofType(updateViewParkHours, updatePersistentParkHoursData), withLatestFrom$1(this.store.pipe(select(gdsPersistentParkHoursData)), this.store.pipe(select(gdsParkHours)), this.store.pipe(select(gdsHamburgerNavData))), mergeMap(([, gdsPersistentParkHoursData, gdsParkHoursData, gdsHamburgerNav,]) => {
            this.globalNav.updateComponentData('gds-park-hours', gdsParkHoursData);
            gdsPersistentParkHoursData?.forEach((component) => this.globalNav.updateComponentData(`.${component.classList.replaceAll(' ', '.')}`, component.data));
            this.globalNav.updateHamburgerNav(gdsHamburgerNav);
            return of([]);
        })), { dispatch: false });
    }
}
ParkHoursEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ParkHoursEffects, deps: [{ token: i1$2.Actions }, { token: GlobalNavService }, { token: i3$1.MsPlacesService }, { token: i4$1.GdsPoiService }, { token: i3.Store }, { token: i13.GdsCommonUtilityService }, { token: 'AppDefaults' }], target: i0.ɵɵFactoryTarget.Injectable });
ParkHoursEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ParkHoursEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ParkHoursEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: GlobalNavService }, { type: i3$1.MsPlacesService }, { type: i4$1.GdsPoiService }, { type: i3.Store }, { type: i13.GdsCommonUtilityService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['AppDefaults']
                }] }]; } });

class ParseEffects {
    constructor(actions$, store, geoLocationService, globalNav, localStorage, parser) {
        this.actions$ = actions$;
        this.store = store;
        this.geoLocationService = geoLocationService;
        this.globalNav = globalNav;
        this.localStorage = localStorage;
        this.parser = parser;
        this.parseUtilityBarContent$ = createEffect(() => this.actions$.pipe(ofType(parseUtilityBarContent), switchMap((state) => {
            const content = state.content;
            const tcmUtilityBar = Array.isArray(content) ? content[0] : content;
            const schemaRootName = get(tcmUtilityBar, 'schemaRootName', '');
            let parsedContent = {};
            if (schemaRootName.toLowerCase().includes('utilitybar')) {
                parsedContent = this.parser.parseUtilityBar(tcmUtilityBar);
            }
            return of(parseUtilityBarContentSuccess({ parsedContent }));
        })));
        this.parseUtilityBarContentSuccess$ = createEffect(() => this.actions$.pipe(ofType(parseUtilityBarContentSuccess), map$1(() => {
            if (this.globalNav.isMobileWebView) {
                return prepareView$1();
            }
            else {
                return getUtilityBarSlotCount$1();
            }
        })));
        this.getUtilityBarSlotCount$ = createEffect(() => this.actions$.pipe(ofType(getUtilityBarSlotCount$1), withLatestFrom$1(this.store.pipe(select(parsedUtilityBarSections))), mergeMap(([_action, tridionContent,]) => {
            const { mobileSlotCount, desktopSlotCount, preUtilitySlotCount } = getUtilityBarSlotCount(tridionContent);
            return [
                updateUtilityBarSlots({
                    mobileSlotCount,
                    desktopSlotCount,
                    preUtilitySlotCount,
                }),
            ];
        })));
        this.updateUtilityBarSlots$ = createEffect(() => this.actions$.pipe(ofType(updateUtilityBarSlots), map$1(() => createUtilityBarSlots())));
        this.removeEmptyPreUtilityBar$ = createEffect(() => this.actions$.pipe(ofType(updateUtilityBarSlots), filter$1(({ preUtilitySlotCount }) => !preUtilitySlotCount), map$1(() => updatePreNavUtility({
            propertyName: 'preUtilityBar',
            propertyValue: null,
        }))));
        this.updatePreNavUtility$ = createEffect(() => this.actions$.pipe(ofType(updateUtilityBarSlots), filter$1(({ preUtilitySlotCount }) => !!preUtilitySlotCount), map$1(() => updateViewParkHours())));
        this.createUtilityBarSlots$ = createEffect(() => this.actions$.pipe(ofType(createUtilityBarSlots), withLatestFrom$1(this.store.pipe(select(utilityBarSlots)), this.store.pipe(select(gdsUtilityBar))), concatMap(([_action, slots, gdsUtilityBar]) => {
            const mobileUtilityBarData = setMobileUtilityBarSlots(slots, gdsUtilityBar);
            return [
                updateUtilitySlots({
                    propertyName: 'utilityBar',
                    propertyValue: mobileUtilityBarData,
                }),
            ];
        })));
        this.updateUtilitySlots$ = createEffect(() => this.actions$.pipe(ofType(updateUtilitySlots), map$1(() => reactivelyLoadParkHours())));
        this.extractParkHours$ = createEffect(() => this.actions$.pipe(ofType(extractParkHours), map$1(() => getVenueId())));
        this.getVenueId$ = createEffect(() => this.actions$.pipe(ofType(getVenueId), withLatestFrom$1(this.store.pipe(select(tridionParkHours))), mergeMap(([_action, tridionContent]) => {
            const blocksData = tridionContent?.blocks?.blocksData;
            const placeIdList = blocksData.map((block) => block?.placeId);
            const placeIds = {
                venue_ids: [...placeIdList],
                place_types: ['Park'],
            };
            return of(setPlaceIds({
                placeIds,
            }));
        })));
        this.transformProfileContent$ = createEffect(() => this.actions$.pipe(ofType(transformProfileContent), withLatestFrom$1(this.store.pipe(select(loggedIn)), this.store.pipe(select(profileContent)), this.store.pipe(select(selectUserNameData)), this.store.pipe(select(gdsProfileSideBar))), mergeMap(([, loggedInValue, profileContent, userValue, gdsProfileSideBar]) => {
            const geoLocation = this.geoLocationService.getGeoLocationObject();
            const geoLocationInitialValue = geoLocation.region !== GEO_NON_PRIMARY_RESIDENT_VALUE;
            let localContrast = this.localStorage.getItem('contrast');
            localContrast =
                localContrast !== null && localContrast !== undefined
                    ? JSON.parse(localContrast)
                    : false;
            const result = setProfileData(profileContent, gdsProfileSideBar, loggedInValue, userValue, geoLocationInitialValue, localContrast);
            return of(updateMapValue({
                propertyName: 'profile',
                propertyValue: result,
            }));
        })));
        this.parseTridionSearchContent$ = createEffect(() => this.actions$.pipe(ofType(parseTridionSearchContent), withLatestFrom$1(this.store.pipe(select(tridionSearchContent)), this.store.pipe(select(gdsSearchBar))), switchMap(([, tridionSearchContent, gdsSearchBar]) => {
            const searchData = setSearchBarData(gdsSearchBar, tridionSearchContent, '', [], false);
            return of(updateMapValue({
                propertyName: 'search',
                propertyValue: searchData,
            }));
        })));
        this.parseMegaNavContent$ = createEffect(() => this.actions$.pipe(ofType(parseMegaNavContent), switchMap((state) => {
            const content = state.content;
            const tcmMegaNav = Array.isArray(content) ? content[0] : content;
            const schemaRootName = get(tcmMegaNav, 'schemaRootName', '');
            let parsedContent = {};
            if (schemaRootName.toLowerCase().includes('meganav')) {
                parsedContent = this.parser.parseMegaNav(tcmMegaNav);
            }
            return of(parseMegaNavContentSuccess({ parsedContent }));
        })));
        this.parseMegaNavContentSuccess$ = createEffect(() => this.actions$.pipe(ofType(parseMegaNavContentSuccess), switchMap((action) => of(transformTridionMegaNavContent(action.parsedContent)))));
    }
}
ParseEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ParseEffects, deps: [{ token: i1$2.Actions }, { token: i3.Store }, { token: i12.GeolocationService }, { token: GlobalNavService }, { token: i5.LocalStorageService }, { token: GlobalNavParserService }], target: i0.ɵɵFactoryTarget.Injectable });
ParseEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ParseEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ParseEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i3.Store }, { type: i12.GeolocationService }, { type: GlobalNavService }, { type: i5.LocalStorageService }, { type: GlobalNavParserService }]; } });

class ProfileEffects {
    constructor(actions$, globalNav, msGuests, store) {
        this.actions$ = actions$;
        this.globalNav = globalNav;
        this.msGuests = msGuests;
        this.store = store;
        this.updateLoginStatus$ = createEffect(() => this.actions$.pipe(ofType(updateLoginStatus), switchMap((action) => of(loginStatus({ loggedIn: action.loggedIn })))));
        this.loginStatus$ = createEffect(() => this.actions$.pipe(ofType(loginStatus), switchMap((action) => {
            if (action.loggedIn) {
                return of(getUserDetails());
            }
            else {
                return of(updateProfileData({ loggedIn: false }));
            }
        })));
        this.getUserDetails$ = createEffect(() => this.actions$.pipe(ofType(getUserDetails), switchMap(() => from(this.msGuests.profile.getByGuestId(this.msGuests.helper.getGuestId())).pipe(map$1((user) => userDetailsSuccess({ user })), catchError((error) => of(userDetailsFailure({ error })))))));
        this.userDetailsSuccess$ = createEffect(() => this.actions$.pipe(ofType(userDetailsSuccess), switchMap(() => {
            return of(updateProfileData({
                loggedIn: true,
            }));
        })));
        this.userDetailsFailure$ = createEffect(() => this.actions$.pipe(ofType(userDetailsFailure), switchMap((error) => {
            this.globalNav.logDdlEvents('Error', 'Failed to load user details', error);
            return of(updateProfileData({
                loggedIn: false,
            }));
        })));
        this.updateProfileData$ = createEffect(() => this.actions$.pipe(ofType(updateProfileData), withLatestFrom$1(this.store.pipe(select(selectUserNameData)), this.store.pipe(select(gdsProfileSideBar))), switchMap(([action, userData, gdsProfileSideBar]) => {
            const updatedGdsProfileSideBar = JSON.parse(JSON.stringify(gdsProfileSideBar));
            if (action.loggedIn) {
                const components = updateGuestName(userData, updatedGdsProfileSideBar.loggedInComponents || [], updatedGdsProfileSideBar.showProfileIcon, updatedGdsProfileSideBar.reverseName);
                set(updatedGdsProfileSideBar, 'components', components);
            }
            else if (!action.loggedIn) {
                set(updatedGdsProfileSideBar, 'components', updatedGdsProfileSideBar.loggedOutComponents || []);
            }
            return of(updateProfileSideBar({
                profile: updatedGdsProfileSideBar,
            }));
        })));
        this.updateProfileComponents$ = createEffect(() => this.actions$.pipe(ofType(updateProfileSideBar), withLatestFrom$1(this.store.pipe(select(gdsHamburgerNav)), this.store.pipe(select(gdsProfileSideBar))), switchMap(([_action, gdsHamburgerNav, gdsProfileSideBar]) => {
            const updatedGdsHamburgerNav = JSON.parse(JSON.stringify(gdsHamburgerNav));
            let components = get(updatedGdsHamburgerNav, 'data.components', []);
            components = components.filter((component) => {
                return component.id !== GDS_HAMBURGER_PROFILE_LAYER_ID;
            });
            components.push(...gdsProfileSideBar.components);
            set(updatedGdsHamburgerNav, 'data.components', components);
            this.globalNav.updateHamburgerNav(updatedGdsHamburgerNav.data);
            this.globalNav.updateComponentData('gds-guest-account', gdsProfileSideBar);
            return of(updateMapValue({
                propertyName: 'hamburgerNav',
                propertyValue: updatedGdsHamburgerNav,
            }));
        })));
    }
}
ProfileEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ProfileEffects, deps: [{ token: i1$2.Actions }, { token: GlobalNavService }, { token: i14.MsGuestsService }, { token: i3.Store }], target: i0.ɵɵFactoryTarget.Injectable });
ProfileEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ProfileEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ProfileEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: GlobalNavService }, { type: i14.MsGuestsService }, { type: i3.Store }]; } });

class SearchEffects {
    constructor(actions$, globalNav, gdsCoveoSearch, store) {
        this.actions$ = actions$;
        this.globalNav = globalNav;
        this.gdsCoveoSearch = gdsCoveoSearch;
        this.store = store;
        this.getCoveoSearchResults$ = createEffect(() => this.actions$.pipe(ofType(coveoSearchQuery$1), withLatestFrom$1(this.store.pipe(select(tridionSearchContent)), this.store.pipe(select(gdsSearchBar))), switchMap(([action, tridionSearchContent, gdsSearchBar]) => from(this.gdsCoveoSearch.search(action.query)).pipe(tap({
            error: () => {
                this.globalNav.logDdlEvents('Error', 'Coveo search failed!', '');
            },
        }), mergeMap((completions) => {
            const parsed = setSearchBarData(gdsSearchBar, tridionSearchContent, action.query, completions, true);
            return [
                coveoSearchResults$1({
                    rawContent: completions,
                    parsed,
                }),
                updateMapValue({
                    propertyName: 'search',
                    propertyValue: parsed,
                }),
                reRenderSearchElement({
                    searchBarEl: parsed,
                }),
            ];
        }), catchError((error) => of(coveoSearchFailure({ error })))))));
        this.reRenderSearchElement$ = createEffect(() => this.actions$.pipe(ofType(reRenderSearchElement), map$1((action) => {
            this.gdsCoveoSearch.updateSearchData(action.searchBarEl);
        })), { dispatch: false });
    }
}
SearchEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SearchEffects, deps: [{ token: i1$2.Actions }, { token: GlobalNavService }, { token: i11.GdsCoveoSearchService }, { token: i3.Store }], target: i0.ɵɵFactoryTarget.Injectable });
SearchEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SearchEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SearchEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: GlobalNavService }, { type: i11.GdsCoveoSearchService }, { type: i3.Store }]; } });

const initialState = {
    account: {
        loggedIn: false,
        user: null,
        userGreeting: '',
    },
    coveo: {
        rawContent: [],
        parsed: [],
    },
    tridionContent: {
        contentUrlInfo: null,
        rawContent: [],
        parsed: {
            utilityBar: null,
            megaNav: null,
            profile: null,
            search: null,
            parkHours: null,
            persistentParkHours: null,
        },
    },
    slots: {
        utilityBar: {
            mobile: null,
            desktop: null,
        },
    },
    hoursApi: {
        msPlaces: null,
        minionService: null,
        placeIds: null,
        timeZone: '',
    },
    gdsComponentData: {
        notifications: createNotificationContainer(),
        preUtilityBar,
        utilityBar,
        mainLinks,
        search: searchBar,
        mega: mega,
        hamburgerNav,
        profile,
        notificationCenter,
        gdsParkHours: null,
    },
    navLite: [],
    view: {
        ready: false,
        components: [],
    },
};
const reducers = createReducer(initialState, on(getContentIdsSuccess, (state, { contentUrlInfo }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: '',
    tridionContent: {
        ...state.tridionContent,
        contentUrlInfo,
    },
})), on(getUtilityBarContentFailure, (state) => ({
    ...state,
    tridionContent: {
        ...state.tridionContent,
        contentUrlInfo: {
            ...state.tridionContent.contentUrlInfo,
            contentIds: {
                ...state.tridionContent.contentUrlInfo?.contentIds,
                global_nav_utility: '',
            },
        },
    },
})), on(getMegaNavContentFailure, (state) => ({
    ...state,
    tridionContent: {
        ...state.tridionContent,
        contentUrlInfo: {
            ...state.tridionContent.contentUrlInfo,
            contentIds: {
                ...state.tridionContent.contentUrlInfo?.contentIds,
                global_nav_main: '',
            },
        },
    },
})), on(loginStatus, (state, { loggedIn }) => ({
    ...state,
    account: {
        ...state.account,
        loggedIn,
    },
})), on(userDetailsSuccess, (state, { user }) => ({
    ...state,
    account: {
        ...state.account,
        user,
    },
    error: null,
})), on(userDetailsFailure, (state, { error }) => ({
    ...state,
    account: {
        ...state.account,
        user: null,
    },
    error,
})), on(parseUtilityBarContentSuccess, (state, { parsedContent }) => ({
    ...state,
    tridionContent: {
        ...state.tridionContent,
        parsed: {
            ...state.tridionContent.parsed,
            utilityBar: parsedContent,
        },
    },
})), on(parseMegaNavContentSuccess, (state, { parsedContent }) => ({
    ...state,
    tridionContent: {
        ...state.tridionContent,
        parsed: {
            ...state.tridionContent.parsed,
            megaNav: parsedContent,
        },
    },
})), on(updateUtilityBarSlots, (state, { mobileSlotCount, desktopSlotCount }) => ({
    ...state,
    slots: {
        ...state.slots,
        utilityBar: {
            mobile: mobileSlotCount,
            desktop: desktopSlotCount,
        },
    },
})), on(updateUtilitySlots, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(setParkHours, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(transformProfileContent, (state, { profileContent }) => ({
    ...state,
    tridionContent: {
        ...state.tridionContent,
        parsed: {
            ...state.tridionContent.parsed,
            profile: profileContent,
        },
    },
})), on(parseTridionSearchContent, (state, { parsedContent }) => ({
    ...state,
    tridionContent: {
        ...state.tridionContent,
        parsed: {
            ...state.tridionContent.parsed,
            search: parsedContent,
        },
    },
})), on(coveoSearchQuery$1, (state, { query }) => ({
    ...state,
    query,
})), on(coveoSearchResults$1, (state, { rawContent, parsed }) => ({
    ...state,
    coveo: {
        ...state.coveo,
        rawContent,
        parsed,
    },
})), on(coveoSearchFailure, (state, { error }) => ({
    ...state,
    error,
})), on(setPersistentHours, (state, { persistentParkHours }) => ({
    ...state,
    tridionContent: {
        ...state.tridionContent,
        parsed: {
            ...state.tridionContent.parsed,
            persistentParkHours: {
                ...state.tridionContent.parsed.persistentParkHours,
                [persistentParkHours.tcmId]: persistentParkHours,
            },
        },
    },
})), on(extractParkHours, (state, { parkHours }) => ({
    ...state,
    tridionContent: {
        ...state.tridionContent,
        parsed: {
            ...state.tridionContent.parsed,
            parkHours,
        },
    },
})), on(getVenuesSuccess, (state, { venues }) => ({
    ...state,
    hoursApi: {
        ...state.hoursApi,
        minionService: venues,
    },
})), on(setTimeZone, (state, { timeZone }) => ({
    ...state,
    hoursApi: {
        ...state.hoursApi,
        timeZone: timeZone,
    },
})), on(setPlaceIds, (state, { placeIds }) => ({
    ...state,
    hoursApi: {
        ...state.hoursApi,
        placeIds: placeIds,
    },
})), on(getMsPlacesParkHoursSuccess, (state, { msPlacesHours }) => ({
    ...state,
    hoursApi: {
        ...state.hoursApi,
        msPlaces: msPlacesHours,
    },
})), on(updateMobileUtility, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(updateUtilityLogo, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(updateSearchUtility, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(updateDesktopUtility, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(updatePersistentParkHoursData, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(updatePreNavUtility, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(updateDesktopUtilityParkHours, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(updateHamburgerNavUtility, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
            utilityBar: {
                ...state.gdsComponentData.utilityBar,
                ready: true,
            },
        },
    };
}), on(updateHamburgerNavMega, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: {
                ...propertyValue,
                ready: true,
            },
        },
    };
}), on(updateHamburgerNavMegaProfile, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(updateProfileSideBar, (state, { profile }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            profile,
        },
    };
}), on(updateNotificationContainer, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(updateNotificationCenter, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(setMapValue, (state, { newValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            newValue,
        },
    };
}), on(updateMapValue, (state, { propertyName, propertyValue }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            [propertyName]: propertyValue,
        },
    };
}), on(updateUserGreetingTemplate, (state, { userGreeting }) => ({
    ...state,
    account: {
        ...state.account,
        userGreeting,
    },
})), on(updateMainLinksMegaNav, (state, { mainLinks, mega }) => {
    return {
        ...state,
        gdsComponentData: {
            ...state.gdsComponentData,
            mainLinks: {
                ...mainLinks,
                ready: true,
            },
            mega,
        },
    };
}), on(updateNavLite, (state, action) => ({
    ...state,
    navLite: action.navLite,
})), on(updateView, (state, { components }) => ({
    ...state,
    view: {
        ...state.view,
        ready: true,
        components,
    },
})));

class GdsGlobalNavModule {
}
GdsGlobalNavModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsGlobalNavModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GdsGlobalNavModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsGlobalNavModule, imports: [MsPlacesModule,
        GdsButtonEventsModule,
        GdsNotificationsModule,
        GdsCoveoSearchModule,
        UprMobileServiceModule, i3.StoreFeatureModule, i1$2.EffectsFeatureModule] });
GdsGlobalNavModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsGlobalNavModule, providers: [GlobalNavService, GlobalNavParserService], imports: [[
            MsPlacesModule,
            GdsButtonEventsModule,
            GdsNotificationsModule,
            GdsCoveoSearchModule,
            UprMobileServiceModule,
            StoreModule.forFeature(NavFeatureKey, reducers),
            EffectsModule.forFeature([
                GlobalNavEffects,
                ParseEffects,
                ProfileEffects,
                ParkHoursEffects,
                SearchEffects,
            ]),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsGlobalNavModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [GlobalNavService, GlobalNavParserService],
                    imports: [
                        MsPlacesModule,
                        GdsButtonEventsModule,
                        GdsNotificationsModule,
                        GdsCoveoSearchModule,
                        UprMobileServiceModule,
                        StoreModule.forFeature(NavFeatureKey, reducers),
                        EffectsModule.forFeature([
                            GlobalNavEffects,
                            ParseEffects,
                            ProfileEffects,
                            ParkHoursEffects,
                            SearchEffects,
                        ]),
                    ],
                }]
        }] });

export { CartStorageKeys, GDS_GLOBAL_NAV, GDS_GLOBAL_NAV_ENV_DEFAULTS, GDS_GLOBAL_NAV_LITE, GDS_HAMBURGER_PRIMARY_LAYER_ID, GDS_HAMBURGER_PROFILE_LAYER_ID, GdsGlobalNavModule, GlobalNavDisplayType, GlobalNavFieldTemplate, GlobalNavService, NavFeatureKey, coveoHighlightHtml, createDividerComponent, createGlobalNavDivider, createHamburgerMegaNavData, createHamburgerProfileData, createHamburgerSubNavData, createNavLiteMain, createNavLiteUtility, createNotificationContainer, findObjectWithXLargeAndGdsButton, formatMsPlaceHours, gdsCtaListHamburgerNav, generateLinkDropdown, generatePersistentParkHours, generateSubPageFromDropdownOptions, getUtilityBarSlotCount, hamburgerNav, hamburgerThirdLayer, initView, mainLinks, mega, notificationCenter, preUtilityBar, prepareNavLiteData, prepareView, processPreUtilityBarData, processSubMegaNav, profile, searchBar, setGdsParkHoursHamburgerNavData, setHamburgerNavData_parkHours_content, setHamburgerNavData_utility_content, setMegaNavData_mega_nav_content, setMobileUtilityBarSlots, setParkHoursData, setParkHoursData_venues, setPersistentParkHoursComponent, setPreNavUtilityBarParkHoursData, setProfileData, setSearchBarData, setSearchBarUtilityBarData, setSubMegaNavContent, setUtilityBarLogoData, setUtilityBarParkHoursData, updateGuestName, updateUserGreetingButton, utilityBar };
